// import React, { useContext, useEffect, useRef, useState } from "react";
// import AdminContext from "../../../StateContext/Application";
// import ReactApexChart from "react-apexcharts";
// import "./MisReport.css";
// import Select from "react-select";
// import {
//   Approved32,
//   Click32,
//   Disable32,
//   Earnings,
//   Earningss,
//   Earningsss,
//   Error32,
//   fifth,
//   first,
//   forth,
//   Graph64,
//   MoreMenu64,
//   NewTasks64,
//   Sales,
//   Second,
//   Spendthismonth64,
//   third,
//   TotalProjects64,
//   Unclick32,
//   YourBalance,
//   ECSFile,
//   TotalAmountRelease,
//   TotalDeductionAmount,
//   TotalDemandGenerations,
//   TotalWorkOrders,
//   TotalProjectCost,
//   TotalEsitmateAmount,
//   TotalHeadsAssigns,
//   DeleteIcon,
//   EditIcon,
//   BudgetHeadCreationBlue32,
// } from "../../../../../public/LoginImages/importimages";
// import "../../../../Users/pages/innercss.css";
// const MisReports = () => {
//   const content = useContext(AdminContext);
//   const { GetProjectInfo, GetBudgetHeadInfo, MisReports } = content;
//   const [schemeType, setSchemeType] = useState("");
//   const [projectdata, setProjectData] = useState([]);
//   const [search, setSearch] = useState("");
//   const [showTable, setShowTable] = useState(0);
//   const [showCards, setShowCards] = useState(false);
//   const [showPage, setShowPage] = useState(0);
//   // const [misData, setMisData] = useState({});
//   const [workOrderList, setWorkOrderList] = useState([]);
//   const [yearList, setYearList] = useState([]);
//   const [agencyList, setAgencyList] = useState([]);
//   const [projectList, setProjectList] = useState([]);
//   const [year, setYear] = useState("");
//   const [agency, setAgency] = useState("");
//   const [projectId, setProjectId] = useState("");
//   const [billList, setBillList] = useState([]);
//   const [vendorList, setVendorList] = useState([]);
//   const [limitAllocationList, setLimitAllocationList] = useState([]);
//   const [fundList, setFundList] = useState([]);
//   // const [subAgencyList, setSubAgencyList] = useState([]);
//   const [headAssignList, setheadAssignList] = useState([]);
//   const [progressReportList, setProgressReportList] = useState([]);
//   const [loadingTable, setLoadingTable] = useState(false);
//   const [yearMenuOpen, setYearMenuOpen] = useState(false);
//   const [agencyMenuOpen, setAgencyMenuOpen] = useState(false);
//   const [projectMenuOpen, setProjectMenuOpen] = useState(false);
//   const [projectPage, setProjectPage] = useState(1);
//   const [billPage, setBillPage] = useState(1);
//   const [deductionPage, setDeductionPage] = useState(1);
//   const [vendorPage, setVendorPage] = useState(1);
//   // const [vendorList, setVendorList] = useState([]);
//   // const [subAgencyPage, setSubAgencyPage] = useState(1);
//   const [headPage, setHeadPage] = useState(1);
//   const [limitPage, setLimitPage] = useState(1);
//   const [fundPage, setFundPage] = useState(1);
//   const [deductionList, setDeductionList] = useState([]);
//   const [progressPage, setProgressPage] = useState(1);


//   // 24-09 agnecy fecthing cahngse

//   const [subAgencyList, setSubAgencyList] = useState([]);
// const [subAgencyPage, setSubAgencyPage] = useState(1);
// const [agencyFilterType, setAgencyFilterType] = useState(""); // was "Agency"
// const [selectedParentAgency, setSelectedParentAgency] = useState(null);



//   const [misData, setMisData] = useState({
//     TotalProjects: 0,
//     BillAmount: 0,
//     DeductionAmount: 0,
//     TotalVendor: 0,
//     TotalLimitAllocation: 0,
//     FundAmount: 0,
//     TotalSubAgency: 0,
//     TotalHeadsAssign: 0,
//     TotalProgressReport: 0,
//   });

//   // Guards against out-of-order / overlapping API responses: every call to
//   // TestMisApi is tagged with the current requestId. If a newer request has
//   // started by the time an older one resolves, the older result is dropped
//   // instead of overwriting fresher state. This is what previously required
//   // an extra click to "fix" the numbers after quickly changing filters.
//   const requestIdRef = useRef({});

//   const GetAgency = async () => {
//     const data = await MisReports({ type: "GetAgency" });
//     setAgencyList(data);
//   };

//   const GetYears = async () => {
//     const res = await MisReports({ type: "GetYears" });
//     console.log("Frontend Years:", res);
//     setYearList(res);
//   };

//   const GetProject = async () => {
//     const data = await MisReports({ type: "GetProject" });
//     setProjectList(data || []);
//   };

//   // On initial mount / page refresh, fetch the grand totals (no scheme,
//   // year, agency, or project filter applied) so the cards show overall
//   // counts and amounts right away, instead of sitting at 0 until the user
//   // picks a Scheme. Once the user selects Scheme/Year/Agency/Project, the
//   // existing handlers below re-fetch and narrow these same cards down to
//   // that selection's filtered totals.
//   const fetchOverallTotals = async () => {
//     await Promise.all([
//       TestMisApi("Project", "", "", "", ""),
//       TestMisApi("BillAmount", "", "", "", ""),
//       TestMisApi("DeductionAmount", "", "", "", ""),
//       TestMisApi("Vendor", "", "", "", ""),
//       TestMisApi("LimitAllocation", "", "", "", ""),
//       TestMisApi("FundAmount", "", "", "", ""),
//       TestMisApi("SubAgency", "", "", "", ""),
//       TestMisApi("ProgressReport", "", "", "", ""),
//       TestMisApi("HeadAssign", "", "", "", ""),
//     ]);
//   };

//   useEffect(() => {
//     GetYears();
//     GetAgency();
//     GetProject();
//     fetchOverallTotals();
//   }, []);

//   const handleYearChange = async (e) => {
//     if (!schemeType) {
//       alert("Please select Scheme first.");
//       return;
//     }
//     const value = e.target.value;
//     setYear(value);
//     setAgency("");
//     setProjectId("");
//     const data = await MisReports({
//       type: "GetAgency",
//       Scheme: schemeType,
//       FinancialYear: value,
//     });
//     setAgencyList(data || []);
//     await Promise.all([
//       TestMisApi("Project", "", schemeType, value),
//       TestMisApi("BillAmount", "", schemeType, value),
//       TestMisApi("DeductionAmount", "", schemeType, value),
//       TestMisApi("LimitAllocation", "", schemeType, value),
//       TestMisApi("FundAmount", "", schemeType, value),
//       TestMisApi("SubAgency", "", schemeType, value),
//       TestMisApi("ProgressReport", "", schemeType, value),
//       ...(schemeType === "Budget"
//         ? [TestMisApi("HeadAssign", "", schemeType, value)]
//         : []),
//     ]);
//   };

//   const handleAgencyChange = async (e) => {
//     if (!schemeType) {
//       alert("Please select Scheme first.");
//       return;
//     }

//     if (!year) {
//       alert("Please select Year first.");
//       return;
//     }
//     const value = e.target.value;
//     setAgency(value);
//     setProjectId("");

//     const data = await MisReports({
//       type: "GetProject",
//       Scheme: schemeType,
//       FinancialYear: year,
//       Agency_Name: value,
//     });
//     setProjectList(data || []);
//     await Promise.all([
//       TestMisApi("Project", value, schemeType, year),
//       TestMisApi("BillAmount", value, schemeType, year),
//       TestMisApi("DeductionAmount", value, schemeType, year),
//       TestMisApi("LimitAllocation", value, schemeType, year),
//       TestMisApi("FundAmount", value, schemeType, year),
//       TestMisApi("SubAgency", value, schemeType, year),
//       TestMisApi("ProgressReport", value, schemeType, year),
//       ...(schemeType === "Budget"
//         ? [TestMisApi("HeadAssign", value, schemeType, year)]
//         : []),
//     ]);
//   };

//   const handleProjectChange = async (e) => {
//     if (!schemeType) {
//       alert("Please select Scheme first.");
//       return;
//     }
//     if (!year) {
//       alert("Please select Year first.");
//       return;
//     }
//     if (!agency) {
//       alert("Please select Agency first.");
//       return;
//     }
//     const value = e.target.value;
//     setProjectId(value);
//     await Promise.all([
//       TestMisApi("Project", agency, schemeType, year, value),
//       TestMisApi("BillAmount", agency, schemeType, year, value),
//       TestMisApi("DeductionAmount", agency, schemeType, year, value),
//       TestMisApi("LimitAllocation", agency, schemeType, year, value),
//       TestMisApi("FundAmount", agency, schemeType, year, value),
//       TestMisApi("ProgressReport", agency, schemeType, year, value),
//       ...(schemeType === "Budget"
//         ? [TestMisApi("HeadAssign", agency, schemeType, year, value)]
//         : []),
//     ]);
//   };

//   useEffect(() => {
//     console.log("Scheme Changed:", schemeType);
//   }, [schemeType]);

//   console.log("misData", misData);
//   const handleSchemeChange = async (e) => {
//     const value = e.target.value;
//     setSchemeType(value);
//     setYear("");
//     setAgency("");
//     setProjectId("");
//     setAgencyList([]);
//     setProjectList([]);

//     setMisData({
//       TotalProjects: 0,
//       BillAmount: 0,
//       DeductionAmount: 0,
//       TotalVendor: 0,
//       TotalLimitAllocation: 0,
//       FundAmount: 0,
//       TotalSubAgency: 0,
//       TotalHeadsAssign: 0,
//       TotalProgressReport: 0,
//     });

//     // Scheme cleared back to "Choose Scheme" — show the overall (unfiltered)
//     // totals again, same as on initial page load, instead of leaving the
//     // cards at 0.
//     if (!value) {
//       await fetchOverallTotals();
//       return;
//     }

//     await Promise.all([
//       TestMisApi("Project", "", value),
//       TestMisApi("BillAmount", "", value),
//       TestMisApi("DeductionAmount", "", value),
//       TestMisApi("LimitAllocation", "", value),
//       TestMisApi("FundAmount", "", value),
//       TestMisApi("SubAgency", "", value),
//       TestMisApi("ProgressReport", "", value),
//       ...(value === "Budget" ? [TestMisApi("HeadAssign", "", value)] : []),
//     ]);

//     GetYears();
//   };

//   const TestMisApi = async (
//     type,
//     agencyCode = agency,
//     Scheme = schemeType,
//     FinancialYear = year,
//     project = projectId,
//   ) => {
//     // Tag this call with a fresh id for its report "type" so that if a newer
//     // request of the SAME type is fired before this one resolves, this
//     // stale response gets dropped instead of overwriting newer state.
//     const myRequestId = (requestIdRef.current[type] || 0) + 1;
//     requestIdRef.current[type] = myRequestId;

//     const res = await MisReports({
//       type,
//       Agency: agencyCode,
//       Scheme,
//       FinancialYear,
//       ProjectId: project,
//     });
//     console.log("API Response:", res);

//     // A newer request for this same report type has since started —
//     // discard this now-stale result.
//     if (requestIdRef.current[type] !== myRequestId) return;

//     if (!res?.success) return;
//     // if (type === "Project") {
//     //   setMisData((prev) => ({
//     //     ...prev,
//     //     TotalProjects: res.TotalProjects,
//     //     Budget_TotalProjects: res.Budget_TotalProjects,
//     //     NonBudget_TotalProjects: res.NonBudget_TotalProjects,
//     //   }));
//     // }
//     if (type === "Project") {
//       console.log("PROJECT API RESPONSE:", res);

//       setMisData((prev) => ({
//         ...prev,
//         TotalProjects: res.TotalProjects || 0,
//         Budget_TotalProjects: res.Budget_TotalProjects || 0,
//         NonBudget_TotalProjects: res.NonBudget_TotalProjects || 0,
//       }));

//       // IMPORTANT:
//       // Store the Project API result in projectList.
//       // This makes FinancialYear and ProjectCost available in the table.
//       setProjectList(
//         Array.isArray(res.ProjectList)
//           ? res.ProjectList
//           : Array.isArray(res.data)
//             ? res.data
//             : [],
//       );
//     } else if (type === "BillAmount") {
//       setMisData((prev) => ({
//         ...prev,
//         BillAmount: res.BillAmount,
//         Budget_BillAmount: res.Budget_BillAmount,
//         NonBudget_BillAmount: res.NonBudget_BillAmount,
//       }));
//       setBillList(res.BillList);
//     } else if (type === "DeductionAmount") {
//       setMisData((prev) => ({
//         ...prev,
//         DeductionAmount: res.DeductionAmount,
//         Budget_DeductionAmount: res.Budget_DeductionAmount,
//         NonBudget_DeductionAmount: res.NonBudget_DeductionAmount,
//       }));
//       setDeductionList(res.BillList);
//     } else if (type === "Vendor") {
//       setMisData((prev) => ({
//         ...prev,
//         TotalVendor: res.TotalVendor,
//       }));
//       setVendorList(res.VendorList);
//     } else if (type === "LimitAllocation") {
//       setMisData((prev) => ({
//         ...prev,
//         TotalLimitAllocation: res.TotalLimitAllocation,
//         Budget_TotalLimitAllocation: res.Budget_TotalLimitAllocation,
//         NonBudget_TotalLimitAllocation: res.NonBudget_TotalLimitAllocation,
//       }));
//       setLimitAllocationList(res.LimitAllocationList);
//     } else if (type === "FundAmount") {
//       setMisData((prev) => ({
//         ...prev,
//         FundAmount: res.FundAmount,
//       }));
//       setFundList(res.FundList);
//     } else if (type === "SubAgency") {
//       setMisData((prev) => ({
//         ...prev,
//         TotalSubAgency: res.TotalSubAgency,
//       }));
//       setSubAgencyList(res.SubAgencyList);
//     } else if (type === "HeadAssign") {
//       setMisData((prev) => ({
//         ...prev,
//         TotalHeadsAssign: res.TotalHeadsAssign,
//       }));
//       setheadAssignList(res.HeadAssignList);
//     } else if (type === "ProgressReport") {
//       setMisData((prev) => ({
//         ...prev,
//         TotalProgressReport: res.TotalProgressReport || 0,
//       }));
//       setProgressReportList(res.ProgressReportList || []);
//     }
//   };

//   // Now awaits the fetch before switching to the detail table, and shows a
//   // loading flag in the meantime, so the table never briefly renders with
//   // stale data from the previous selection.
//   // const handleCardClick = async (card) => {
//   //   setLoadingTable(true);
//   //   await TestMisApi(card.type, agency, schemeType, year, projectId);
//   //   setLoadingTable(false);
//   //   setShowTable(card.id);
//   // };



//   // 24-09 agnecy fetching changes

// const handleCardClick = async (card) => {
//   setLoadingTable(true);
//   if (card.type === "SubAgency") {
//     setAgencyFilterType("");
//     if (agency) {
//       // Top filter has an Agency selected — show ITS sub-agencies, not the full list
//       setSelectedParentAgency({ name: agency, code: null });
//       await fetchAgencyChildren(agency); // sends Agency_Name; backend resolves it via CASE B
//     } else {
//       setSelectedParentAgency(null);
//       await fetchAgencyList();
//     }
//   } else {
//     await TestMisApi(card.type, agency, schemeType, year, projectId);
//   }
//   setLoadingTable(false);
//   setShowTable(card.id);
// };


//   const handleSearch = async (e) => {
//     const value = e.target.value;
//     setSearch(value);
//     await TestMisApi("Project", value);
//     await TestMisApi("BillAmount", value);
//     await TestMisApi("DeductionAmount", value);
//     setShowCards(true);
//   };

//   // const filteredProjects = (projectList || []).filter((p) => {
//   //   const value = search.trim().toLowerCase();
//   //   return (
//   //     p.ProjectName?.toLowerCase().includes(value) ||
//   //     p.ProjectID?.toString().includes(value)
//   //   );
//   // });
//   const filteredProjects = (projectList || []).filter((p) => {
//     const value = search.trim().toLowerCase();

//     return (
//       String(p.ProjectName || "")
//         .toLowerCase()
//         .includes(value) ||
//       String(p.ProjectId || p.ProjectID || "")
//         .toLowerCase()
//         .includes(value) ||
//       String(
//         p.FinancialYear || p.financialyear || p.Financial_Year || p.FY || "",
//       )
//         .toLowerCase()
//         .includes(value)
//     );
//   });

//   const filteredBills = (billList || []).filter((item) => {
//     const value = search.trim().toLowerCase();

//     return (
//       item.ProjectName?.toLowerCase().includes(value) ||
//       item.ProjectID?.toString().includes(value) ||
//       item.BillNumber?.toLowerCase().includes(value) ||
//       item.VendorName?.toLowerCase().includes(value) ||
//       item.Agency_Name?.toLowerCase().includes(value)
//     );
//   });


//  // 19-10-2026 deduction pagination work
//  const filteredDeductions = (deductionList || [])
//   // hide entries where deduction amount is 0
//   .filter((item) => Number(item.DeductionAmount || 0) > 0)
//   .filter((item) => {
//     const value = search.trim().toLowerCase();
//     return (
//       String(item.ProjectName || "").toLowerCase().includes(value) ||
//       String(item.ProjectID || "").toLowerCase().includes(value) ||
//       String(item.DemandGenerationID || "").toLowerCase().includes(value) ||
//       String(item.ContractorName || "").toLowerCase().includes(value)
//     );
//   });


//   const filteredVendors = (vendorList || []).filter((item) => {
//     const value = search.trim().toLowerCase();
//     return item.Bidder_CompanyName.toLowerCase().includes(value);
//   });

//   const filteredLimits = (limitAllocationList || []).filter((item) => {
//     const value = search.trim().toLowerCase();
//     return (
//       item.ProjectName?.toLowerCase().includes(value) ||
//       item.FinancialYear.toLowerCase().includes(value) ||
//       item.BudgetHead.toLowerCase().includes(value) ||
//       item.Agency_Name?.toLowerCase().includes(value)
//     );
//   });

//   const filteredFunds = (fundList || []).filter((item) => {
//     const value = search.trim().toLowerCase();
//     return (
//       item.Year.toLowerCase().includes(value) ||
//       item.Status.toLowerCase().includes(value) ||
//       item.FundAmount.toLowerCase().includes(value) ||
//       item.UTRNumber.toLowerCase().includes(value) ||
//       item.LetterNumber.toLowerCase().includes(value) ||
//       item.GRNumber.toLowerCase().includes(value)
//     );
//   });

//   // const filteredAgency = (subAgencyList || []).filter((item) => {
//   //   const value = search.trim().toLowerCase();
//   //   return (
//   //     item.Agency_Name.toLowerCase().includes(value) ||
//   //     item.City.toLowerCase().includes(value) ||
//   //     item.Email.toLowerCase().includes(value)
//   //   );
//   // });

//   // 26-09 filter 
//   const filteredAgency = (subAgencyList || []).filter((item) => {
//   const value = search.trim().toLowerCase();

//   const matchesSearch =
//     (item.Agency_Name || "").toLowerCase().includes(value) ||
//     (item.City || "").toLowerCase().includes(value) ||
//     (item.Email || "").toLowerCase().includes(value);

//   // Filter only applies at the top level (Agency Admin / New Agency Admin list).
//   // Once drilled into a specific agency's staff, the filter is irrelevant.
//   const matchesFilter =
//     !agencyFilterType || selectedParentAgency || item.RoleType === agencyFilterType;

//   return matchesSearch && matchesFilter;
// });

//   const filteredHead = (headAssignList || []).filter((item) => {
//     const value = search.trim().toLowerCase();
//     return (
//       item.FinancialYear.toLowerCase().includes(value) ||
//       item.HeadName.toLowerCase().includes(value)
//     );
//   });


// // 05-10 add serach functionality
// const filteredProgressList = (progressReportList || []).filter((item) => {
//   const value = search.trim().toLowerCase();

//   return (
//     String(item.ProjectID || "")
//       .toLowerCase()
//       .includes(value) ||
//     String(item.ProjectName || "")
//       .toLowerCase()
//       .includes(value) ||
//     String(item.FinancialYear || "")
//       .toLowerCase()
//       .includes(value) ||
//     String(item.WorkName || "")
//       .toLowerCase()
//       .includes(value)
//   );
// });

// const filteredProjectList = (projectList || []).filter((item) => {
//   const value = search.trim().toLowerCase();

//   return (
//     String(item.ProjectId || item.ProjectID || "")
//       .toLowerCase()
//       .includes(value) ||
//     String(item.ProjectName || "")
//       .toLowerCase()
//       .includes(value) ||
//     String(
//       item.FinancialYear ||
//         item.financialyear ||
//         item.Financial_Year ||
//         item.FY ||
//         ""
//     )
//       .toLowerCase()
//       .includes(value)
//   );
// });
// // ---------

//   const TotalProjects =
//     schemeType === "Budget"
//       ? misData?.Budget_TotalProjects
//       : schemeType === "NonBudget"
//         ? misData?.NonBudget_TotalProjects
//         : misData?.TotalProjects;
//   const BillAmount =
//     schemeType === "Budget"
//       ? misData?.Budget_BillAmount
//       : schemeType === "NonBudget"
//         ? misData?.NonBudget_BillAmount
//         : misData?.BillAmount;
//   const DeductionAmount =
//     schemeType === "Budget"
//       ? misData?.Budget_DeductionAmount
//       : schemeType === "NonBudget"
//         ? misData?.NonBudget_DeductionAmount
//         : misData?.DeductionAmount;
//   const TotalLimitAllocation =
//     schemeType === "Budget"
//       ? misData?.Budget_TotalLimitAllocation
//       : schemeType === "NonBudget"
//         ? misData?.NonBudget_TotalLimitAllocation
//         : misData?.TotalLimitAllocation;

//   const TotalProgressReport =
//     schemeType === "Budget"
//       ? misData?.Budget_TotalProgressReport
//       : schemeType === "NonBudget"
//         ? misData?.NonBudget_TotalProgressReport
//         : misData?.TotalProgressReport;

//   const cards = [
//     {
//       id: 1,
//       title: "Total Project Cost",
//       value: Number(TotalProjects || 0).toLocaleString("en-IN"),
//      icon: "/MIS-Total Project Cost.png",
//       showArrow: true,
//       type: "Project",
//     },
//     {
//       id: 2,
//       title: "Total Bill Amount",
//       value: `₹ ${Number(BillAmount || 0).toLocaleString("en-IN")}`,
//          icon: "/MIS-Total-Bill-Amount.png",
//       showArrow: true,
//       type: "BillAmount",
//     },
//     {
//       id: 3,
//       title: "Total Deduction",
//       value: `₹ ${Number(DeductionAmount || 0).toLocaleString("en-IN")}`,
//       icon: "/MIS-Total-Deduction.png",
//       showArrow: true,
//       type: "DeductionAmount",
//     },
//     {
//       id: 4,
//       title: "Total Number Of Vendor",
//       value: misData.TotalVendor || 0,
//       icon: "/MIS-Total-Number-Of-Vendor.png",
//       showArrow: true,
//       type: "Vendor",
//     },
//     {
//       id: 5,
//       title: "Total Limit Allocation",
//       value: `₹ ${Number(TotalLimitAllocation || 0).toLocaleString("en-IN")}`,
//       icon: "/MIS-Total-Limit-Allocation.png",
//       showArrow: true,
//       type: "LimitAllocation",
//     },
//     {
//       id: 6,
//       title: "Total Fund Amount",
//       value: `₹ ${Number(misData.FundAmount || 0).toLocaleString("en-IN")}`,
//        icon: "/MIS-Total-Fund-Amount.png",
//       showArrow: true,
//       type: "FundAmount",
//     },
//     {
//       id: 7,
//       title: "Total Progress Report",
//       value: misData.TotalProgressReport || 0,
//      icon: "/MIS-Total-Progress-Report.png",
//       showArrow: true,
//       type: "ProgressReport",
//     },
//     {
//       id: 8,
//       title: "Total Agency",
//       value: misData.TotalSubAgency || 0,
//        icon: "/MIS-Total-Sub-Agency.png",
//       showArrow: true,
//       type: "SubAgency",
//     },
//   ];

//   const displayCards =
//     schemeType === "Budget"
//       ? [
//           ...cards,
//           {
//             id: 9,
//             title: "Total Head Assign",
//             value: misData.TotalHeadsAssign || 0,
//             icon: "/MIS-Total-Number-Of-Vendor.png",
//             showArrow: true,
//             type: "HeadAssign",
//             style: { border: "1px solid black", borderRadius: "8px", }, 
//           },
//         ]
//       : cards;

//   const getPageNumbers = (currentPage, totalPages) => {
//     if (totalPages <= 5) {
//       return Array.from({ length: totalPages }, (_, index) => index + 1);
//     }

//     if (currentPage <= 3) {
//       return [1, 2, 3, 4, 5, "...", totalPages];
//     }

//     if (currentPage >= totalPages - 2) {
//       return [
//         1,
//         "...",
//         totalPages - 4,
//         totalPages - 3,
//         totalPages - 2,
//         totalPages - 1,
//         totalPages,
//       ];
//     }

//     return [
//       1,
//       "...",
//       currentPage - 1,
//       currentPage,
//       currentPage + 1,
//       "...",
//       totalPages,
//     ];
//   };

//   // const projectsPerPage = 10;

//   // const projectTotalPages = Math.ceil(projectList.length / projectsPerPage);

//   // const projectIndexOfLast = projectPage * projectsPerPage;

//   // const projectIndexOfFirst = projectIndexOfLast - projectsPerPage;

//   // const currentProjectList = projectList.slice(
//   //   projectIndexOfFirst,
//   //   projectIndexOfLast,
//   // );
//   // 05-10 add seraching functionallity
// const projectPerPage = 10;

// const projectTotalPages = Math.ceil(
//   filteredProjectList.length / projectPerPage
// );

// const projectIndexOfLast = projectPage * projectPerPage;

// const projectIndexOfFirst =
//   projectIndexOfLast - projectPerPage;

// const currentProjectList = filteredProjectList.slice(
//   projectIndexOfFirst,
//   projectIndexOfLast
// );
//   // ================= BILL DETAILS PAGINATION =================

//   const billsPerPage = 10;

//   const billTotalPages = Math.ceil(filteredBills.length / billsPerPage);

//   const billIndexOfLast = billPage * billsPerPage;

//   const billIndexOfFirst = billIndexOfLast - billsPerPage;

//   const currentBillList = filteredBills.slice(
//     billIndexOfFirst,
//     billIndexOfLast,
//   );

//   // ================= DEDUCTION DETAILS PAGINATION =================

//   const deductionsPerPage = 10;

//  const deductionTotalPages = Math.ceil(
//   filteredDeductions.length / deductionsPerPage,
// );

// const deductionIndexOfLast = deductionPage * deductionsPerPage;

// const deductionIndexOfFirst = deductionIndexOfLast - deductionsPerPage;

// const currentDeductionList = filteredDeductions.slice(
//   deductionIndexOfFirst,
//   deductionIndexOfLast,
// );

//   // ================= VENDOR DETAILS PAGINATION =================

//   const vendorsPerPage = 10;

//   const vendorTotalPages = Math.ceil(filteredVendors.length / vendorsPerPage);

//   const vendorIndexOfLast = vendorPage * vendorsPerPage;

//   const vendorIndexOfFirst = vendorIndexOfLast - vendorsPerPage;

//   const currentVendorList = filteredVendors.slice(
//     vendorIndexOfFirst,
//     vendorIndexOfLast,
//   );

//   const limitsPerPage = 10;

//   const limitTotalPages = Math.ceil(filteredLimits.length / limitsPerPage);

//   const limitIndexOfLast = limitPage * limitsPerPage;

//   const limitIndexOfFirst = limitIndexOfLast - limitsPerPage;

//   const currentLimitList = filteredLimits.slice(
//     limitIndexOfFirst,
//     limitIndexOfLast,
//   );

//   // ================= FUND DETAILS PAGINATION =================

//   const fundsPerPage = 10;

//   const fundTotalPages = Math.ceil(filteredFunds.length / fundsPerPage);

//   const fundIndexOfLast = fundPage * fundsPerPage;

//   const fundIndexOfFirst = fundIndexOfLast - fundsPerPage;

//   const currentFundList = filteredFunds.slice(
//     fundIndexOfFirst,
//     fundIndexOfLast,
//   );

//   // ================= SUB AGENCY DETAILS PAGINATION =================

//   const subAgenciesPerPage = 10;

//   const subAgencyTotalPages = Math.ceil(
//     filteredAgency.length / subAgenciesPerPage,
//   );

//   const subAgencyIndexOfLast = subAgencyPage * subAgenciesPerPage;

//   const subAgencyIndexOfFirst = subAgencyIndexOfLast - subAgenciesPerPage;

//   const currentSubAgencyList = filteredAgency.slice(
//     subAgencyIndexOfFirst,
//     subAgencyIndexOfLast,
//   );

//   // ================= TOTAL HEAD DETAILS PAGINATION =================

//   const headsPerPage = 10;

//   const headTotalPages = Math.ceil(filteredHead.length / headsPerPage);

//   const headIndexOfLast = headPage * headsPerPage;

//   const headIndexOfFirst = headIndexOfLast - headsPerPage;

//   const currentHeadList = filteredHead.slice(headIndexOfFirst, headIndexOfLast);



//   // 05-10 add seraching functionallity
//  const progressPerPage = 10;

// const progressTotalPages = Math.ceil(
//   filteredProgressList.length / progressPerPage
// );

// const progressIndexOfLast = progressPage * progressPerPage;

// const progressIndexOfFirst = progressIndexOfLast - progressPerPage;

// const currentProgressList = filteredProgressList.slice(
//   progressIndexOfFirst,
//   progressIndexOfLast
// );



//   // 24-09 agnecy fetching functionality changes
// const fetchAgencyList = async () => {
//   const res = await MisReports({ type: "SubAgency", Agency: "" });
//   setMisData((prev) => ({ ...prev, TotalSubAgency: res?.TotalSubAgency || 0 }));
//   setSubAgencyList(res?.SubAgencyList || []);
//   setSubAgencyPage(1);
// };

// const handleAgencyFilterChange = (selected) => {
//   setAgencyFilterType(selected ? selected.value : ""); // clearing goes back to placeholder
//   setSubAgencyPage(1);
// };

// const handleBackToAgencyList = async () => {
//   setSelectedParentAgency(null);
//   await fetchAgencyList();
// };
// // 24-09 fetch agnecy wise 
// // const handleAgencyRowClick = async (item) => {
// //   if (agencyFilterType !== "Agency") return; // only top-level rows drill down
// //   setSelectedParentAgency({ name: item.Agency_Name, code: item.Unique_Agency_Code });
// //   await fetchAgencyList("Agency", item.Agency_Name);
// // };

// // 26-09 fetching aagnec with child ex maker and checker
// const fetchAgencyChildren = async (agencyCode) => {
//   const res = await MisReports({ type: "SubAgency", Agency: agencyCode }); // was "AgencyChildren"
//   setMisData((prev) => ({ ...prev, TotalSubAgency: res?.TotalSubAgency || 0 })); // was res?.TotalChildren
//   setSubAgencyList(res?.SubAgencyList || []); // was res?.ChildrenList
//   setSubAgencyPage(1);
// };
// const handleAgencyRowClick = async (item) => {
//   if (!item.IsDrillable) return; // Agency Admin rows and staff rows do nothing on click
//   setSelectedParentAgency({ name: item.Agency_Name, code: item.Unique_Agency_Code });
//   await fetchAgencyChildren(item.Unique_Agency_Code);
// };

//   return (
//     <>
//       <div
//         style={{
//           background: "#ffffff",
//           width: "auto",
//           maxHeight: "90vh",
//           transition: "margin-left 0.3s ease",
//           overflowY: "auto",
//           msOverflowStyle: "none",
//           scrollbarWidth: "none",
//           padding: 20,
//           fontFamily: "Inter, sans-serif",
//         }}
//         className="no-scrollbar"
//       >
//         <div className="mis-container">
//           {showTable === 0 && (
//             <>
//               <h5
//                 className="mis-heading"
//                 style={{
//                   fontWeight: 800,
//                   marginLeft: 20,
//                   marginBottom: 20,
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 10,
//                 }}
//               >
//                 <img
//                   src={"/Dashboard-Blue-32.png"}
//                   alt="Project Icon"
//                   style={{ width: 28, height: 28 }}
//                 />{" "}
//                 MIS Report
//               </h5>
//               {/* Filters */}
//               <div className="mis-filter-section">
//                 <div className="mis-filter-row">
//                   {/* Scheme */}
//                   <div className="mis-filter-group">
//                     <label>Scheme :</label>

//                     <Select
//                       classNamePrefix="mis-select"
//                       options={[
//                         { value: "Budget", label: "Budget" },
//                         { value: "NonBudget", label: "Non Budget" },
//                       ]}
//                       value={
//                         schemeType
//                           ? {
//                               value: schemeType,
//                               label:
//                                 schemeType === "NonBudget"
//                                   ? "Non Budget"
//                                   : "Budget",
//                             }
//                           : null
//                       }
//                       onChange={(selected) =>
//                         handleSchemeChange({
//                           target: { value: selected ? selected.value : "" },
//                         })
//                       }
//                       placeholder="Choose Scheme"
//                       isSearchable
//                       isClearable
//                     />
//                   </div>

//                   {/* Year */}
//                   <div className="mis-filter-group">
//                     <label>Select Year :</label>

//                     <Select
//                       classNamePrefix="mis-select"
//                       options={yearList.map((item) => ({
//                         value: item.FinancialYear,
//                         label: item.FinancialYear,
//                       }))}
//                       value={year ? { value: year, label: year } : null}
//                       onChange={(selected) =>
//                         handleYearChange({
//                           target: { value: selected ? selected.value : "" },
//                         })
//                       }
//                       placeholder="Choose Year"
//                       isSearchable
//                       isClearable
//                       // onMenuOpen={() => {
//                       //   if (!schemeType) {
//                       //     alert("Please select Scheme first.");
//                       //   }
//                       // }}
//                       // isDisabled={!schemeType}
//                       onMenuOpen={() => {
//                         if (!schemeType) {
//                           alert("Please select Scheme first.");
//                           setYearMenuOpen(false);
//                         } else {
//                           setYearMenuOpen(true);
//                         }
//                       }}
//                       onMenuClose={() => setYearMenuOpen(false)}
//                     />
//                   </div>

//                   {/* Agency */}
//                   <div className="mis-filter-group">
//                     <label>Select Agency :</label>

//                     <Select
//                       classNamePrefix="mis-select"
//                       options={agencyList.map((item) => ({
//                         value: item.Agency_Name,
//                         label: item.Agency_Name,
//                       }))}
//                       value={agency ? { value: agency, label: agency } : null}
//                       onChange={(selected) =>
//                         handleAgencyChange({
//                           target: { value: selected ? selected.value : "" },
//                         })
//                       }
//                       placeholder="Choose Agency"
//                       isSearchable
//                       isClearable
//                       // onMenuOpen={() => {
//                       //   if (!schemeType) {
//                       //     alert("Please select Scheme first.");
//                       //   } else if (!year) {
//                       //     alert("Please select Year first.");
//                       //   }
//                       // }}
//                       // isDisabled={!schemeType || !year}
//                       onMenuOpen={() => {
//                         if (!schemeType) {
//                           alert("Please select Scheme first.");
//                           setAgencyMenuOpen(false);
//                         } else if (!year) {
//                           alert("Please select Year first.");
//                           setAgencyMenuOpen(false);
//                         } else {
//                           setAgencyMenuOpen(true);
//                         }
//                       }}
//                       onMenuClose={() => setAgencyMenuOpen(false)}
//                     />
//                   </div>
//                   <div style={{ display: "flex", justifyContent: "center" }}>
//                     <div style={{ display: "flex", justifyContent: "center" }}>
//                       <div className="mis-filter-group">
//                         <label>Select Project :</label>

//                         <Select
//                           classNamePrefix="mis-select"
//                           options={(projectList || []).map((item) => ({
//                             value: item.ProjectId,
//                             label: item.ProjectName,
//                           }))}
//                           value={
//                             projectList
//                               .map((item) => ({
//                                 value: item.ProjectId,
//                                 label: item.ProjectName,
//                               }))
//                               .find((opt) => opt.value === projectId) || null
//                           }
//                           onChange={(selected) =>
//                             handleProjectChange({
//                               target: { value: selected ? selected.value : "" },
//                             })
//                           }
//                           placeholder="Choose Project"
//                           isSearchable
//                           isClearable
//                           noOptionsMessage={() => "No project found"}
//                           // onMenuOpen={() => {
//                           //   if (!schemeType) {
//                           //     alert("Please select Scheme first.");
//                           //   } else if (!year) {
//                           //     alert("Please select Year first.");
//                           //   } else if (!agency) {
//                           //     alert("Please select Agency first.");
//                           //   }
//                           // }}
//                           // isDisabled={!schemeType || !year || !agency}
//                           onMenuOpen={() => {
//                             if (!schemeType) {
//                               alert("Please select Scheme first.");
//                               setProjectMenuOpen(false);
//                             } else if (!year) {
//                               alert("Please select Year first.");
//                               setProjectMenuOpen(false);
//                             } else if (!agency) {
//                               alert("Please select Agency first.");
//                               setProjectMenuOpen(false);
//                             } else {
//                               setProjectMenuOpen(true);
//                             }
//                           }}
//                           onMenuClose={() => setProjectMenuOpen(false)}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Cards */}
//               <div className="mis-card-wrapper">
//                 {displayCards.map((item, index) => (
//                   <div className="mis-card" key={index}>
//                     <div className="mis-card-icon">
//                       <img src={item.icon} alt={item.title} />
//                     </div>
//                     <div className="mis-card-content">
//                       <h6>{item.title}</h6>
//                       <h3>{item.value}</h3>
//                     </div>
//                     {item.showArrow && (
//                       <div
//                         className="metric-arrow"
//                         onClick={() => handleCardClick(item)}
//                         style={{ cursor: "pointer" }}
//                       >
//                         <img
//                           src="/Arrow64.png"
//                           alt="arrow"
//                           className="metric-arrow-img"
//                         />
//                       </div>
//                     )}
//                   </div>
//                 ))}
//               </div>
//             </>
//           )}

//           {/* =============table show=================== */}

//           {showTable === 1 && (
//             <div className="project-details-card">
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginBottom: "20px",
//                 }}
//               >
//                 <div
//                   style={{ display: "flex", alignItems: "center", gap: "12px" }}
//                 >
//                   <button
//                     // onClick={() => setShowTable(0)}
//                       onClick={() => {
//   setSearch("");
//   setShowTable(0);
// }} //10-10 for serach clear
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <img
//                       src="/Back-Arrow-32.jpg"
//                       alt="Back"
//                       style={{ width: "32px" }}
//                     />
//                   </button>
//                   <h4 style={{ margin: 0, fontWeight: "700" }}>
//                     Total Projects Details{" "}
//                   </h4>
//                 </div>
//                 {/* 24-09 search change */}
//                  <div
//   style={{
//     position: "relative",
//     width: "190px",
//   }}
// >
//   <img
//     src="/Search-32.png"
//     alt="search"
//     style={{
//       position: "absolute",
//       left: "10px",
//       top: "50%",
//       transform: "translateY(-50%)",
//       width: "18px",
//       height: "18px",
//       pointerEvents: "none",
//     }}
//   />
//                 <input
//                   type="text"
//                   placeholder="Search Project..."
//                   value={search}
//                   // onChange={(e) => setSearch(e.target.value) } 05-10
//          onChange={(e) => {
//   setSearch(e.target.value);
//   setProjectPage(1);
// }}
//                   onClick={handleSearch}
                  
//                     style={{
//       width: "190px",
//       height: "38px",
//       padding: "8px 8px 8px 35px",
//       border: "1px solid #ccc",
//       borderRadius: "6px",
//       fontSize: "13px",
//       boxSizing: "border-box",
//     }}
 
                  
//                 />
//                 </div>
//               </div>

//               <div className="table-responsive">
//                 <table className="project-table">
//                   <thead>
//                     <tr>
//                       <th style={{ width: "60px" }}>Sr.No</th>
//                       <th>Financial Year</th>
//                       <th>Project ID</th>
//                       <th>Project Name</th>
                      
//                       <th>Project Cost</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {currentProjectList.length > 0 ? (
//                       currentProjectList.map((item, index) => (
//                         <tr key={item.ProjectId || index}>
//                           <td>{projectIndexOfFirst + index + 1}</td>
//   <td style={{textAlign:"center"}}>
//                             {item.FinancialYear ||
//                               item.financialyear ||
//                               item.Financial_Year ||
//                               item.FY ||
//                               "--"}
//                           </td>
//                           <td style={{ textAlign: "center", color: "rgb(82, 149, 201)" }}>
//                             {item.ProjectId || item.ProjectID || "--"}
//                           </td>

//                           <td>{item.ProjectName || "--"}</td>

                        

//                           <td>
//                             ₹{" "}
//                             {item.ProjectCost !== undefined &&
//                             item.ProjectCost !== null &&
//                             item.ProjectCost !== ""
//                               ? Number(item.ProjectCost).toLocaleString("en-IN")
//                               : item.Project_Cost !== undefined &&
//                                   item.Project_Cost !== null
//                                 ? Number(item.Project_Cost).toLocaleString(
//                                     "en-IN",
//                                   )
//                                 : "--"}
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td
//                           colSpan="5"
//                           style={{
//                             textAlign: "center",
//                             padding: "20px",
//                           }}
//                         >
//                           No Project Found
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//               {/* -----------pagination add --20-08----- */}
//               <div
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginTop: "12px",
//                   padding: "8px 5px",
//                   boxSizing: "border-box",
//                 }}
//               >
//                 {/* Showing Entries */}
//                 <div
//                   style={{
//                     fontSize: "13px",
//                     color: "#333",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   {/* Showing{" "}
//                   {projectList.length === 0 ? 0 : projectIndexOfFirst + 1} to{" "}
//                   {Math.min(projectIndexOfLast, projectList.length)} of{" "}
//                   {projectList.length} entries */}
//                   {/* 05-10 */}
//                   Showing{" "}
// {filteredProjectList.length === 0 ? 0 : projectIndexOfFirst + 1} to{" "}
// {Math.min(projectIndexOfLast, filteredProjectList.length)} of{" "}
// {filteredProjectList.length} entries
//                 </div>

//                 {/* Pagination */}
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "18px",
//                   }}
//                 >
//                   {/* Previous */}
//                   <button
//                     onClick={() =>
//                       setProjectPage((prev) => Math.max(prev - 1, 1))
//                     }
//                     disabled={projectPage === 1}
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: "#2ea4e7",
//                       cursor: projectPage === 1 ? "not-allowed" : "pointer",
//                       fontSize: "13px",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "5px",
//                       opacity: projectPage === 1 ? 0.5 : 1,
//                     }}
//                   >
//                     <span style={{ fontSize: "16px" }}>‹</span>
//                     Previous
//                   </button>

//                   {/* Dynamic Page Numbers */}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "20px",
//                     }}
//                   >
//                     {getPageNumbers(projectPage, projectTotalPages).map(
//                       (pageNumber, index) => {
//                         if (pageNumber === "...") {
//                           return <span key={`project-dots-${index}`}>...</span>;
//                         }

//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => setProjectPage(pageNumber)}
//                             style={{
//                               border: "none",
//                               background: "transparent",
//                               padding: 0,
//                               color:
//                                 projectPage === pageNumber ? "#2ea4e7" : "#444",
//                               cursor: "pointer",
//                               fontSize: "13px",
//                               fontWeight:
//                                 projectPage === pageNumber ? "600" : "400",
//                               textDecoration:
//                                 projectPage === pageNumber
//                                   ? "underline"
//                                   : "none",
//                             }}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       },
//                     )}
//                   </div>

//                   {/* Next */}
//                   <button
//                     onClick={() =>
//                       setProjectPage((prev) =>
//                         Math.min(prev + 1, projectTotalPages),
//                       )
//                     }
//                     disabled={
//                       projectPage === projectTotalPages ||
//                       projectTotalPages === 0
//                     }
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: "#2ea4e7",
//                       cursor:
//                         projectPage === projectTotalPages ||
//                         projectTotalPages === 0
//                           ? "not-allowed"
//                           : "pointer",
//                       fontSize: "13px",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "5px",
//                       opacity:
//                         projectPage === projectTotalPages ||
//                         projectTotalPages === 0
//                           ? 0.5
//                           : 1,
//                     }}
//                   >
//                     Next
//                     <span style={{ fontSize: "16px" }}>›</span>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {showTable === 2 && (
//             <div className="project-details-card">
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginBottom: "20px",
//                 }}
//               >
//                 <div
//                   style={{ display: "flex", alignItems: "center", gap: "12px" }}
//                 >
//                   <button
//                     // onClick={() => setShowTable(0)}
//                      onClick={() => {
//   setSearch("");
//   setShowTable(0);
// }} //10-10 for serach clear
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <img
//                       src="/Back-Arrow-32.jpg"
//                       alt="Back"
//                       style={{ width: "32px" }}
//                     />
//                   </button>
//                   <h4 style={{ margin: 0, fontWeight: "700" }}>
//                     Bill Details{" "}
//                   </h4>
//                 </div>
//                  <div
//   style={{
//     position: "relative",
//     width: "190px",
//   }}
// >
//   <img
//     src="/Search-32.png"
//     alt="search"
//     style={{
//       position: "absolute",
//       left: "10px",
//       top: "50%",
//       transform: "translateY(-50%)",
//       width: "18px",
//       height: "18px",
//       pointerEvents: "none",
//     }}
//   />
//                 <input
//                   type="text"
//                   placeholder="Search Project..."
//                   value={search}
//                   onChange={(e) => setSearch(e.target.value)}
//                   onClick={handleSearch}
//                    style={{
//       width: "190px",
//       height: "38px",
//       padding: "8px 8px 8px 35px",
//       border: "1px solid #ccc",
//       borderRadius: "6px",
//       fontSize: "13px",
//       boxSizing: "border-box",
//     }}
 
//                 />
//                 </div>
//               </div>

//               <div className="table-responsive">
//                 <table className="project-table">
//                   <thead>
//                     <tr>
//                       <th style={{ width: "60px" }}>Sr No</th>
//                       <th>Demand ID</th>
//                       <th>Project Name</th>
//                       <th>Contractor Name</th>
//                       <th>RA Bill No</th>
//                       <th>Bill Amount</th>
//                       <th>Deduction Amount</th>
//                       <th>Net Payable</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {currentBillList.length > 0 ? (
//                       currentBillList.map((item, index) => (
//                         <tr key={item.DemandGenerationID}>
//                           <td>{billIndexOfFirst + index + 1}</td>
//                           <td style={{ color: "rgb(82, 149, 201)",textAlign:"center"}}>{item.DemandGenerationID}</td>
//                           <td>{item.ProjectName}</td>
//                           <td>{item.ContractorName}</td>
//                           <td>{item.RABillNumber}</td>
//                           <td>
//                             {" "}
//                             ₹{" "}
//                             {Number(item.BillAmount || 0).toLocaleString(
//                               "en-IN",
//                             )}{" "}
//                           </td>
//                           <td>
//                             {" "}
//                             ₹{" "}
//                             {Number(item.DeductionAmount || 0).toLocaleString(
//                               "en-IN",
//                             )}{" "}
//                           </td>
//                           <td>
//                             {" "}
//                             ₹{" "}
//                             {Number(item.NetPayableAmount || 0).toLocaleString(
//                               "en-IN",
//                             )}{" "}
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="8" style={{ textAlign: "center" }}>
//                           {" "}
//                           No Records Found{" "}
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//               {/* pagination add---20-08 */}

//               <div
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginTop: "12px",
//                   padding: "8px 5px",
//                   boxSizing: "border-box",
//                 }}
//               >
//                 {/* Showing Entries */}
//                 <div
//                   style={{
//                     fontSize: "13px",
//                     color: "#333",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   Showing {billList.length === 0 ? 0 : billIndexOfFirst + 1} to{" "}
//                   {Math.min(billIndexOfLast, billList.length)} of{" "}
//                   {billList.length} entries
//                 </div>

//                 {/* Pagination */}
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "18px",
//                   }}
//                 >
//                   {/* Previous */}
//                   <button
//                     onClick={() => setBillPage((prev) => Math.max(prev - 1, 1))}
//                     disabled={billPage === 1}
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: "#2ea4e7",
//                       cursor: billPage === 1 ? "not-allowed" : "pointer",
//                       fontSize: "13px",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "5px",
//                       opacity: billPage === 1 ? 0.5 : 1,
//                     }}
//                   >
//                     <span style={{ fontSize: "16px" }}>‹</span>
//                     Previous
//                   </button>

//                   {/* Dynamic Page Numbers */}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "20px",
//                     }}
//                   >
//                     {getPageNumbers(billPage, billTotalPages).map(
//                       (pageNumber, index) => {
//                         if (pageNumber === "...") {
//                           return (
//                             <span
//                               key={`bill-dots-${index}`}
//                               style={{
//                                 fontSize: "13px",
//                                 color: "#444",
//                               }}
//                             >
//                               ...
//                             </span>
//                           );
//                         }

//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => setBillPage(pageNumber)}
//                             style={{
//                               border: "none",
//                               background: "transparent",
//                               padding: 0,
//                               color:
//                                 billPage === pageNumber ? "#2ea4e7" : "#444",
//                               cursor: "pointer",
//                               fontSize: "13px",
//                               fontWeight:
//                                 billPage === pageNumber ? "600" : "400",
//                               textDecoration:
//                                 billPage === pageNumber ? "underline" : "none",
//                             }}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       },
//                     )}
//                   </div>

//                   {/* Next */}
//                   <button
//                     onClick={() =>
//                       setBillPage((prev) => Math.min(prev + 1, billTotalPages))
//                     }
//                     disabled={
//                       billPage === billTotalPages || billTotalPages === 0
//                     }
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: "#2ea4e7",
//                       cursor:
//                         billPage === billTotalPages || billTotalPages === 0
//                           ? "not-allowed"
//                           : "pointer",
//                       fontSize: "13px",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "5px",
//                       opacity:
//                         billPage === billTotalPages || billTotalPages === 0
//                           ? 0.5
//                           : 1,
//                     }}
//                   >
//                     Next
//                     <span style={{ fontSize: "16px" }}>›</span>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {showTable === 3 && (
//             <div className="project-details-card">
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginBottom: "20px",
//                 }}
//               >
//                 <div
//                   style={{ display: "flex", alignItems: "center", gap: "12px" }}
//                 >
//                   <button
//                     // onClick={() => setShowTable(0)}
//                      onClick={() => {
//   setSearch("");
//   setShowTable(0);
// }} //10-10 for serach clear
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <img
//                       src="/Back-Arrow-32.jpg"
//                       alt="Back"
//                       style={{ width: "32px" }}
//                     />
//                   </button>
//                   <h4 style={{ margin: 0, fontWeight: "700" }}>
//                     Deduction Details{" "}
//                   </h4>
//                 </div>
//                  <div
//   style={{
//     position: "relative",
//     width: "190px",
//   }}
// ><img
//     src="/Search-32.png"
//     alt="search"
//     style={{
//       position: "absolute",
//       left: "10px",
//       top: "50%",
//       transform: "translateY(-50%)",
//       width: "18px",
//       height: "18px",
//       pointerEvents: "none",
//     }}
//   />
//                 <input
//                   type="text"
//                   placeholder="Search Project..."
//                   value={search}
//                   // onChange={(e) => setSearch(e.target.value)}
//                   // onClick={handleSearch}
//                         // 19-10
//                   onChange={(e) => {
//                             setSearch(e.target.value);
//                             setDeductionPage(1);
//                           }}

//                   style={{
//       width: "190px",
//       height: "38px",
//       padding: "8px 8px 8px 35px",
//       border: "1px solid #ccc",
//       borderRadius: "6px",
//       fontSize: "13px",
//       boxSizing: "border-box",
//     }}
 
//                 />
//                 </div>
//               </div>

//               <div className="table-responsive">
//                 <table className="project-table">
//                   <thead>
//                     <tr>
//                       <th style={{ width: "60px" }}>Sr No</th>
//                       <th>Demand ID</th>
//                       <th>Project Name</th>
//                       <th>Bill Amount</th>
//                       <th>Deduction Amount</th>
//                       <th>Net Payable</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {currentDeductionList.length > 0 ? (
//                       currentDeductionList.map((item, index) => (
//                         <tr key={item.DemandGenerationID}>
//                           {/* <td>{index + 1}</td>
//                           19-10 */}
//                           <td>{deductionIndexOfFirst + index+1}</td>
//                           <td style={{ color: "rgb(82, 149, 201)",textAlign:"center"}}>{item.DemandGenerationID}</td>
//                           <td>{item.ProjectName}</td>
//                           <td>
//                             {" "}
//                             ₹{" "}
//                             {Number(item.BillAmount || 0).toLocaleString(
//                               "en-IN",
//                             )}{" "}
//                           </td>
//                           <td>
//                             {" "}
//                             ₹{" "}
//                             {Number(item.DeductionAmount || 0).toLocaleString(
//                               "en-IN",
//                             )}{" "}
//                           </td>
//                           <td>
//                             {" "}
//                             ₹{" "}
//                             {Number(item.NetPayableAmount || 0).toLocaleString(
//                               "en-IN",
//                             )}{" "}
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         {/* 01-10 */}
//                         <td colSpan="6" style={{ textAlign: "center" }}>
//                           {" "}
//                           No Records Found{" "}
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//               <div
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginTop: "12px",
//                   padding: "8px 5px",
//                   boxSizing: "border-box",
//                 }}
//               >
//                 {/* Showing Entries */}
//                 <div
//                   style={{
//                     fontSize: "13px",
//                     color: "#333",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   {" "}
//                                   {/* 19-10  */}
//                   Showing{" "}
// {filteredDeductions.length === 0
//   ? 0
//   : deductionIndexOfFirst + 1}{" "}
// to {Math.min(deductionIndexOfLast, filteredDeductions.length)} of{" "}
// {filteredDeductions.length} entries 
//                 </div>

//                 {/* Pagination */}
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "10px",
//                   }}
//                 >
//                   {/* Previous */}
//                   <button
//                     onClick={() =>
//                       setDeductionPage((prev) => Math.max(prev - 1, 1))
//                     }
//                     disabled={deductionPage === 1}
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: "#2ea4e7",
//                       cursor: deductionPage === 1 ? "not-allowed" : "pointer",
//                       fontSize: "13px",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "5px",
//                       opacity: deductionPage === 1 ? 0.5 : 1,
//                     }}
//                   >
//                     <span style={{ fontSize: "16px" }}>‹</span>
//                     Previous
//                   </button>

//                   {/* Page Numbers */}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "20px",
//                     }}
//                   >
//                     {getPageNumbers(deductionPage, deductionTotalPages).map(
//                       (pageNumber, index) => {
//                         if (pageNumber === "...") {
//                           return (
//                             <span
//                               key={`deduction-dots-${index}`}
//                               style={{
//                                 fontSize: "13px",
//                                 color: "#444",
//                               }}
//                             >
//                               ...
//                             </span>
//                           );
//                         }

//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => setDeductionPage(pageNumber)}
//                             style={{
//                               border: "none",
//                               background: "transparent",
//                               padding: 0,
//                               color:
//                                 deductionPage === pageNumber
//                                   ? "#2ea4e7"
//                                   : "#444",
//                               cursor: "pointer",
//                               fontSize: "13px",
//                               fontWeight:
//                                 deductionPage === pageNumber ? "600" : "400",
//                               textDecoration:
//                                 deductionPage === pageNumber
//                                   ? "underline"
//                                   : "none",
//                             }}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       },
//                     )}
//                   </div>
//                   {/* Next */}
//                   <button
//                     onClick={() =>
//                       setDeductionPage((prev) =>
//                         Math.min(prev + 1, deductionTotalPages),
//                       )
//                     }
//                     disabled={
//                       deductionPage === deductionTotalPages ||
//                       deductionTotalPages === 0
//                     }
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: "#2ea4e7",
//                       cursor:
//                         deductionPage === deductionTotalPages ||
//                         deductionTotalPages === 0
//                           ? "not-allowed"
//                           : "pointer",
//                       fontSize: "13px",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "5px",
//                       opacity:
//                         deductionPage === deductionTotalPages ||
//                         deductionTotalPages === 0
//                           ? 0.5
//                           : 1,
//                     }}
//                   >
//                     Next
//                     <span style={{ fontSize: "16px" }}>›</span>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {showTable === 4 && (
//             <div className="project-details-card">
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginBottom: "20px",
//                 }}
//               >
//                 <div
//                   style={{ display: "flex", alignItems: "center", gap: "12px" }}
//                 >
//                   <button
//                     // onClick={() => setShowTable(0)}
//                      onClick={() => {
//   setSearch("");
//   setShowTable(0);
// }} //10-10 for serach clear
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <img
//                       src="/Back-Arrow-32.jpg"
//                       alt="Back"
//                       style={{ width: "32px" }}
//                     />
//                   </button>
//                   <h4 style={{ margin: 0, fontWeight: "700" }}>
//                     Vendors Details
//                   </h4>
//                 </div>
//                  <div
//   style={{
//     position: "relative",
//     width: "190px",
//   }}
// ><img
//     src="/Search-32.png"
//     alt="search"
//     style={{
//       position: "absolute",
//       left: "10px",
//       top: "50%",
//       transform: "translateY(-50%)",
//       width: "18px",
//       height: "18px",
//       pointerEvents: "none",
//     }}
//   />
//                 <input
//                   type="text"
//                   placeholder="Search Project..."
//                   value={search}
//                   onChange={(e) => setSearch(e.target.value)}
//                   onClick={handleSearch}
//                    style={{
//       width: "190px",
//       height: "38px",
//       padding: "8px 8px 8px 35px",
//       border: "1px solid #ccc",
//       borderRadius: "6px",
//       fontSize: "13px",
//       boxSizing: "border-box",
//     }}
 
//                 />
//                 </div>
//               </div>
//               <div className="table-responsive">
//                 <table className="project-table">
//                   <thead>
//                     <tr>
//                       <th style={{ width: "60px" }}>Sr No</th>
//                       <th>Vendor ID</th>
//                       <th>Company Name</th>
//                       <th>Mobile</th>
//                       <th>Email</th>
//                       <th>GST No</th>
//                       <th>PAN No</th>
//                       <th>Bank Name</th>
//                       <th>Branch</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentVendorList.length > 0 ? (
//                       currentVendorList.map((item, index) => (
//                         <tr key={item.UniqueID}>
//                           <td>{vendorIndexOfFirst + index + 1}</td>
//                           <td style={{ color: "rgb(82, 149, 201)",textAlign:"center"}}>{item.UniqueID}</td>
//                           <td>{item.Bidder_CompanyName}</td>
//                           <td>{item.Mobile_No}</td>
//                           <td>{item.Email}</td>
//                           <td>{item.GST_No}</td>
//                           <td>{item.PAN_No}</td>
//                           <td>{item.BANK_NAME}</td>
//                           <td>{item.BranchName}</td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="9" style={{ textAlign: "center" }}>
//                           {" "}
//                           No Records Found{" "}
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//               <div
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginTop: "12px",
//                   padding: "8px 5px",
//                   boxSizing: "border-box",
//                 }}
//               >
//                 {/* Showing Entries */}
//                 <div
//                   style={{
//                     fontSize: "13px",
//                     color: "#333",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   Showing {vendorList.length === 0 ? 0 : vendorIndexOfFirst + 1}{" "}
//                   to {Math.min(vendorIndexOfLast, vendorList.length)} of{" "}
//                   {vendorList.length} entries
//                 </div>

//                 {/* Pagination */}
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "18px",
//                   }}
//                 >
//                   {/* Previous */}
//                   <button
//                     onClick={() =>
//                       setVendorPage((prev) => Math.max(prev - 1, 1))
//                     }
//                     disabled={vendorPage === 1}
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: "#2ea4e7",
//                       cursor: vendorPage === 1 ? "not-allowed" : "pointer",
//                       fontSize: "13px",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "5px",
//                       opacity: vendorPage === 1 ? 0.5 : 1,
//                     }}
//                   >
//                     <span style={{ fontSize: "16px" }}>‹</span>
//                     Previous
//                   </button>

//                   {/* Page Numbers */}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "20px",
//                     }}
//                   >
//                     {getPageNumbers(vendorPage, vendorTotalPages).map(
//                       (pageNumber, index) => {
//                         if (pageNumber === "...") {
//                           return (
//                             <span
//                               key={`vendor-dots-${index}`}
//                               style={{
//                                 fontSize: "13px",
//                                 color: "#444",
//                               }}
//                             >
//                               ...
//                             </span>
//                           );
//                         }

//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => setVendorPage(pageNumber)}
//                             style={{
//                               border: "none",
//                               background: "transparent",
//                               padding: 0,
//                               color:
//                                 vendorPage === pageNumber ? "#2ea4e7" : "#444",
//                               cursor: "pointer",
//                               fontSize: "13px",
//                               fontWeight:
//                                 vendorPage === pageNumber ? "600" : "400",
//                               textDecoration:
//                                 vendorPage === pageNumber
//                                   ? "underline"
//                                   : "none",
//                             }}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       },
//                     )}
//                   </div>

//                   {/* Next */}
//                   <button
//                     onClick={() =>
//                       setVendorPage((prev) =>
//                         Math.min(prev + 1, vendorTotalPages),
//                       )
//                     }
//                     disabled={
//                       vendorPage === vendorTotalPages || vendorTotalPages === 0
//                     }
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: "#2ea4e7",
//                       cursor:
//                         vendorPage === vendorTotalPages ||
//                         vendorTotalPages === 0
//                           ? "not-allowed"
//                           : "pointer",
//                       fontSize: "13px",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "5px",
//                       opacity:
//                         vendorPage === vendorTotalPages ||
//                         vendorTotalPages === 0
//                           ? 0.5
//                           : 1,
//                     }}
//                   >
//                     Next
//                     <span style={{ fontSize: "16px" }}>›</span>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {showTable === 5 && (
//             <div className="project-details-card">
//               {/* Header */}
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginBottom: "20px",
//                 }}
//               >
//                 <div
//                   style={{ display: "flex", alignItems: "center", gap: "12px" }}
//                 >
//                   <button
//                     // onClick={() => setShowTable(0)}
//                      onClick={() => {
//   setSearch("");
//   setShowTable(0);
// }} //10-10 for serach clear
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <img
//                       src="/Back-Arrow-32.jpg"
//                       alt="Back"
//                       style={{ width: "32px" }}
//                     />
//                   </button>
//                   <h4 style={{ margin: 0, fontWeight: "700" }}>
//                     {" "}
//                     Limit Allocation Details{" "}
//                   </h4>
//                 </div>
//                  <div
//   style={{
//     position: "relative",
//     width: "190px",
//   }}
// ><img
//     src="/Search-32.png"
//     alt="search"
//     style={{
//       position: "absolute",
//       left: "10px",
//       top: "50%",
//       transform: "translateY(-50%)",
//       width: "18px",
//       height: "18px",
//       pointerEvents: "none",
//     }}
//   />
//                 <input
//                   type="text"
//                   placeholder="Search Project..."
//                   value={search}
//                   onChange={(e) => setSearch(e.target.value)}
//                   onClick={handleSearch}
//                   style={{
//       width: "190px",
//       height: "38px",
//       padding: "8px 8px 8px 35px",
//       border: "1px solid #ccc",
//       borderRadius: "6px",
//       fontSize: "13px",
//       boxSizing: "border-box",
//     }}
 
//                 />
//               </div></div>
//               <div className="table-responsive">
//                 <table className="project-table">
//                   <thead>
//                     <tr>
//                       <th style={{ width: "60px" }}>Sr No</th>
//                       <th>Release ID</th>
//                       <th>Financial Year</th>
//                       <th>Project Name</th>
//                       {schemeType === "Budget" && <th>Budget Head</th>}
//                       <th>Agency</th>
//                       <th>Release Amount</th>
//                       <th>Release Date</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {currentLimitList.length > 0 ? (
//                       currentLimitList.map((item, index) => (
//                         <tr key={item.ReleaseID}>
//                           <td>{limitIndexOfFirst + index + 1}</td>
//                           <td style={{ color: "rgb(82, 149, 201)",textAlign:"center"}}>{item.ReleaseID}</td>
//                           <td>{item.FinancialYear}</td>
//                           <td>{item.ProjectName}</td>
//                           {schemeType === "Budget" && (
//                             <td>{item.BudgetHead}</td>
//                           )}
//                           <td>{item.AgencyName}</td>
//                           <td>
//                             {" "}
//                             ₹{" "}
//                             {Number(item.ReleaseAmount || 0).toLocaleString(
//                               "en-IN",
//                             )}{" "}
//                           </td>
//                           <td>
//                             {" "}
//                             {new Date(item.ReleaseDate).toLocaleDateString(
//                               "en-GB",
//                             )}
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="7" style={{ textAlign: "center" }}>
//                           {" "}
//                           No Records Found{" "}
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>

//               <div
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginTop: "12px",
//                   padding: "8px 5px",
//                   boxSizing: "border-box",
//                 }}
//               >
//                 {/* Showing Entries */}
//                 <div
//                   style={{
//                     fontSize: "13px",
//                     color: "#333",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   Showing{" "}
//                   {limitAllocationList.length === 0 ? 0 : limitIndexOfFirst + 1}{" "}
//                   to {Math.min(limitIndexOfLast, limitAllocationList.length)} of{" "}
//                   {limitAllocationList.length} entries
//                 </div>

//                 {/* Pagination */}
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "18px",
//                   }}
//                 >
//                   {/* Previous */}
//                   <button
//                     onClick={() =>
//                       setLimitPage((prev) => Math.max(prev - 1, 1))
//                     }
//                     disabled={limitPage === 1}
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: "#2ea4e7",
//                       cursor: limitPage === 1 ? "not-allowed" : "pointer",
//                       fontSize: "13px",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "5px",
//                       opacity: limitPage === 1 ? 0.5 : 1,
//                     }}
//                   >
//                     <span style={{ fontSize: "16px" }}>‹</span>
//                     Previous
//                   </button>

//                   {/* Page Numbers */}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "20px",
//                     }}
//                   >
//                     {getPageNumbers(limitPage, limitTotalPages).map(
//                       (pageNumber, index) => {
//                         if (pageNumber === "...") {
//                           return (
//                             <span
//                               key={`limit-dots-${index}`}
//                               style={{
//                                 fontSize: "13px",
//                                 color: "#444",
//                               }}
//                             >
//                               ...
//                             </span>
//                           );
//                         }

//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => setLimitPage(pageNumber)}
//                             style={{
//                               border: "none",
//                               background: "transparent",
//                               padding: 0,
//                               color:
//                                 limitPage === pageNumber ? "#2ea4e7" : "#444",
//                               cursor: "pointer",
//                               fontSize: "13px",
//                               fontWeight:
//                                 limitPage === pageNumber ? "600" : "400",
//                               textDecoration:
//                                 limitPage === pageNumber ? "underline" : "none",
//                             }}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       },
//                     )}
//                   </div>

//                   {/* Next */}
//                   <button
//                     onClick={() =>
//                       setLimitPage((prev) =>
//                         Math.min(prev + 1, limitTotalPages),
//                       )
//                     }
//                     disabled={
//                       limitPage === limitTotalPages || limitTotalPages === 0
//                     }
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: "#2ea4e7",
//                       cursor:
//                         limitPage === limitTotalPages || limitTotalPages === 0
//                           ? "not-allowed"
//                           : "pointer",
//                       fontSize: "13px",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "5px",
//                       opacity:
//                         limitPage === limitTotalPages || limitTotalPages === 0
//                           ? 0.5
//                           : 1,
//                     }}
//                   >
//                     Next
//                     <span style={{ fontSize: "16px" }}>›</span>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {showTable === 6 && (
//             <div className="project-details-card">
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginBottom: "20px",
//                 }}
//               >
//                 <div
//                   style={{ display: "flex", alignItems: "center", gap: "12px" }}
//                 >
//                   <button
//                     // onClick={() => setShowTable(0)}
//                      onClick={() => {
//   setSearch("");
//   setShowTable(0);
// }} //10-10 for serach clear
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <img
//                       src="/Back-Arrow-32.jpg"
//                       alt="Back"
//                       style={{ width: "32px" }}
//                     />
//                   </button>
//                   <h4 style={{ margin: 0, fontWeight: "700" }}>
//                     Funds Details{" "}
//                   </h4>
//                 </div>
//                  <div
//   style={{
//     position: "relative",
//     width: "190px",
//   }}
// ><img
//     src="/Search-32.png"
//     alt="search"
//     style={{
//       position: "absolute",
//       left: "10px",
//       top: "50%",
//       transform: "translateY(-50%)",
//       width: "18px",
//       height: "18px",
//       pointerEvents: "none",
//     }}
//   />
//                 <input
//                   type="text"
//                   placeholder="Search Project..."
//                   value={search}
//                   onChange={(e) => setSearch(e.target.value)}
//                   onClick={handleSearch}
//                    style={{
//       width: "190px",
//       height: "38px",
//       padding: "8px 8px 8px 35px",
//       border: "1px solid #ccc",
//       borderRadius: "6px",
//       fontSize: "13px",
//       boxSizing: "border-box",
//     }}
 
//                 />
//               </div>
//               </div>
//               <div className="table-responsive">
//                 <table className="project-table">
//                   <thead>
//                     <tr>
//                       <th style={{ width: "60px" }}>Sr No</th>
//                       <th>Fund ID</th>
//                       <th>Year</th>
//                       <th>GR Number</th>
//                       <th>Letter Number</th>
//                       <th>UTR Number</th>
//                       <th>Fund Amount</th>
//                       <th>Used Fund</th>
//                       <th>Remaining Fund</th>
//                       <th>Status</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {/* {currentFundList.map((item, index) => ( */}
//                     {/* 01-10 */}
//                      {currentFundList.length > 0 ? (
//     currentFundList.map((item, index) => (
 
//                       <tr key={index}>
//                         <td>{fundIndexOfFirst + index + 1}</td>
//                         <td style={{ color: "rgb(82, 149, 201)",textAlign:"center"}}>{item.FundID}</td>
//                         <td>{item.Year}</td>
//                         <td>{item.GRNumber}</td>
//                         <td>{item.LetterNumber}</td>
//                         <td>{item.UTRNumber}</td>
//                         <td>
//                           ₹ {Number(item.FundAmount).toLocaleString("en-IN")}
//                         </td>
//                         <td>
//                           ₹{" "}
//                           {Number(item.UsedFundAmount).toLocaleString("en-IN")}
//                         </td>
//                         <td>
//                           ₹{" "}
//                           {Number(item.RemainingFundAmount).toLocaleString(
//                             "en-IN",
//                           )}
//                         </td>
//                         <td>{item.Status}</td>
//                       {/* </tr>
//                     ))}
//                   </tbody> */}
//                   {/* 01-10 */}
//                     </tr>
//     ))
//   ) : (
//     <tr>
//       <td
//         colSpan="10"
//         style={{
//           textAlign: "center",
//           padding: "20px",
//           height: "50px",
//           color: "#777",
//           fontSize: "13px",
//           fontWeight: "500",
//         }}
//       >
//         No Data Available
//       </td>
//     </tr>
//   )}
// </tbody>
 

//                 </table>
//               </div>
//               <div
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginTop: "12px",
//                   padding: "8px 5px",
//                   boxSizing: "border-box",
//                 }}
//               >
//                 {/* Showing Entries */}
//                 <div
//                   style={{
//                     fontSize: "13px",
//                     color: "#333",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   Showing {fundList.length === 0 ? 0 : fundIndexOfFirst + 1} to{" "}
//                   {Math.min(fundIndexOfLast, fundList.length)} of{" "}
//                   {fundList.length} entries
//                 </div>

//                 {/* Pagination */}
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "18px",
//                   }}
//                 >
//                   {/* Previous */}
//                   <button
//                     onClick={() => setFundPage((prev) => Math.max(prev - 1, 1))}
//                     disabled={fundPage === 1}
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: "#2ea4e7",
//                       cursor: fundPage === 1 ? "not-allowed" : "pointer",
//                       fontSize: "13px",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "5px",
//                       opacity: fundPage === 1 ? 0.5 : 1,
//                     }}
//                   >
//                     <span style={{ fontSize: "16px" }}>‹</span>
//                     Previous
//                   </button>

//                   {/* Page Numbers */}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "20px",
//                     }}
//                   >
//                     {getPageNumbers(fundPage, fundTotalPages).map(
//                       (pageNumber, index) => {
//                         if (pageNumber === "...") {
//                           return (
//                             <span
//                               key={`fund-dots-${index}`}
//                               style={{
//                                 fontSize: "13px",
//                                 color: "#444",
//                               }}
//                             >
//                               ...
//                             </span>
//                           );
//                         }

//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => setFundPage(pageNumber)}
//                             style={{
//                               border: "none",
//                               background: "transparent",
//                               padding: 0,
//                               color:
//                                 fundPage === pageNumber ? "#2ea4e7" : "#444",
//                               cursor: "pointer",
//                               fontSize: "13px",
//                               fontWeight:
//                                 fundPage === pageNumber ? "600" : "400",
//                               textDecoration:
//                                 fundPage === pageNumber ? "underline" : "none",
//                             }}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       },
//                     )}
//                   </div>

//                   {/* Next */}
//                   <button
//                     onClick={() =>
//                       setFundPage((prev) => Math.min(prev + 1, fundTotalPages))
//                     }
//                     disabled={
//                       fundPage === fundTotalPages || fundTotalPages === 0
//                     }
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: "#2ea4e7",
//                       cursor:
//                         fundPage === fundTotalPages || fundTotalPages === 0
//                           ? "not-allowed"
//                           : "pointer",
//                       fontSize: "13px",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "5px",
//                       opacity:
//                         fundPage === fundTotalPages || fundTotalPages === 0
//                           ? 0.5
//                           : 1,
//                     }}
//                   >
//                     Next
//                     <span style={{ fontSize: "16px" }}>›</span>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {showTable === 7 && (
//             <div className="project-details-card">
//               {" "}
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   marginBottom: 20,
//                 }}
//               >
//                 {" "}
//                 <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
//                   {" "}
//                   <button
//                     // onClick={() => setShowTable(0)}
//                      onClick={() => {
//   setSearch("");
//   setShowTable(0);
// }} //10-10 for serach clear
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       cursor: "pointer",
//                     }}
//                   >
//                     {" "}
//                     <img
//                       src="/Back-Arrow-32.jpg"
//                       alt="Back"
//                       style={{ width: 32 }}
//                     />{" "}
//                   </button>{" "}
//                   <h4 style={{ margin: 0, fontWeight: "700" }}>
//                     {" "}
//                     Total Progress Report Details{" "}
//                   </h4>{" "}
//                 </div>{" "}

// {/* 05-10 add serch functionality */}
//  <div
//   style={{
//     position: "relative",
//     width: "190px",
//   }}
// ><img
//     src="/Search-32.png"
//     alt="search"
//     style={{
//       position: "absolute",
//       left: "10px",
//       top: "50%",
//       transform: "translateY(-50%)",
//       width: "18px",
//       height: "18px",
//       pointerEvents: "none",
//     }}
//   />
//                 <input
//                   type="text"
//                   placeholder="Search Project..."
//                   value={search}
//                   // onChange={(e) => setSearch(e.target.value)} 05-10
//                   onChange={(e) => {
//   setSearch(e.target.value);
//   setProgressPage(1);
// }}
//                   onClick={handleSearch}
//                    style={{
//       width: "190px",
//       height: "38px",
//       padding: "8px 8px 8px 35px",
//       border: "1px solid #ccc",
//       borderRadius: "6px",
//       fontSize: "13px",
//       boxSizing: "border-box",
//     }}
 
//                 />
//               </div>


//               </div>{" "}
//               <div className="table-responsive">
//                 {" "}
//                 <table className="project-table">
//                   {" "}
//                   <thead>
//                     {" "}
//                     <tr>
//                       {" "}
//                       <th style={{ width: "60px" }}>Sr No</th>{" "}
//                       <th>Project ID</th> <th>Project Name</th>{" "}
//                       <th>Financial Year</th> <th>Work Name</th>{" "}
//                       <th>Physical Progress</th> <th>Creation Date</th>{" "}
//                     </tr>{" "}
//                   </thead>{" "}
//                   <tbody>
//                     {" "}
//                     {currentProgressList.length > 0 ? (
//                       currentProgressList.map((item, index) => (
//                         <tr key={item.ID}>
//                           {" "}
//                           <td>{progressIndexOfFirst + index + 1}</td>{" "}
//                           <td style={{ color: "rgb(82, 149, 201)", fontWeight:"700",textAlign:"center"}}>{item.ProjectID}</td> <td>{item.ProjectName}</td>{" "}
//                           <td>{item.FinancialYear}</td> <td>{item.WorkName}</td>{" "}
//                           <td>{item.PhysicalProgress}%</td>{" "}
//                           <td>
//                             {" "}
//                             {new Date(item.CreationDate).toLocaleDateString(
//                               "en-GB",
//                             )}{" "}
//                           </td>{" "}
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         {" "}
//                         <td colSpan="7" style={{ textAlign: "center" }}>
//                           {" "}
//                           No Progress Report Found{" "}
//                         </td>{" "}
//                       </tr>
//                     )}{" "}
//                   </tbody>{" "}
//                 </table>{" "}
//               </div>{" "}
//               <div
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginTop: "12px",
//                   padding: "8px 5px",
//                   boxSizing: "border-box",
//                 }}
//               >
//                 {/* Showing Entries */}
//                 <div
//                   style={{
//                     fontSize: "13px",
//                     color: "#333",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   {/* Showing{" "}
//                   {progressReportList.length === 0
//                     ? 0
//                     : progressIndexOfFirst + 1}{" "}
//                   to {Math.min(progressIndexOfLast, progressReportList.length)}{" "}
//                   of {progressReportList.length} entries */}
//                   {/* 05-10 */}
//                   Showing{" "}
// {filteredProgressList.length === 0
//   ? 0
//   : progressIndexOfFirst + 1}{" "}
// to {Math.min(progressIndexOfLast, filteredProgressList.length)}{" "}
// of {filteredProgressList.length} entries
//                 </div>

//                 {/* Pagination */}
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "10px",
//                   }}
//                 >
//                   {/* Previous */}
//                   <button
//                     onClick={() =>
//                       setProgressPage((prev) => Math.max(prev - 1, 1))
//                     }
//                     disabled={progressPage === 1}
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: "#2ea4e7",
//                       cursor: progressPage === 1 ? "not-allowed" : "pointer",
//                       fontSize: "13px",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "5px",
//                       opacity: progressPage === 1 ? 0.5 : 1,
//                     }}
//                   >
//                     <span style={{ fontSize: "16px" }}>‹</span>
//                     Previous
//                   </button>

//                   {/* Page Numbers */}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "20px",
//                     }}
//                   >
//                     {getPageNumbers(progressPage, progressTotalPages).map(
//                       (pageNumber, index) => {
//                         if (pageNumber === "...") {
//                           return (
//                             <span
//                               key={`progress-dots-${index}`}
//                               style={{
//                                 fontSize: "13px",
//                                 color: "#444",
//                               }}
//                             >
//                               ...
//                             </span>
//                           );
//                         }

//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => setProgressPage(pageNumber)}
//                             style={{
//                               border: "none",
//                               background: "transparent",
//                               padding: 0,
//                               color:
//                                 progressPage === pageNumber
//                                   ? "#2ea4e7"
//                                   : "#444",
//                               cursor: "pointer",
//                               fontSize: "13px",
//                               fontWeight:
//                                 progressPage === pageNumber ? "600" : "400",
//                               textDecoration:
//                                 progressPage === pageNumber
//                                   ? "underline"
//                                   : "none",
//                             }}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       },
//                     )}
//                   </div>

//                   {/* Next */}
//                   <button
//                     onClick={() =>
//                       setProgressPage((prev) =>
//                         Math.min(prev + 1, progressTotalPages),
//                       )
//                     }
//                     disabled={
//                       progressPage === progressTotalPages ||
//                       progressTotalPages === 0
//                     }
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: "#2ea4e7",
//                       cursor:
//                         progressPage === progressTotalPages ||
//                         progressTotalPages === 0
//                           ? "not-allowed"
//                           : "pointer",
//                       fontSize: "13px",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "5px",
//                       opacity:
//                         progressPage === progressTotalPages ||
//                         progressTotalPages === 0
//                           ? 0.5
//                           : 1,
//                     }}
//                   >
//                     Next
//                     <span style={{ fontSize: "16px" }}>›</span>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {showTable === 8 && (
//             <div className="project-details-card">
            


//               {/* 24-09 Agnecy fetching changes */}

//               <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "20px" }}>
//   <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//     <button
//       onClick={() => (selectedParentAgency ? handleBackToAgencyList() : setShowTable(0))}
//       style={{ border: "none", background: "transparent", cursor: "pointer" }}
//     >
//       <img src="/Back-Arrow-32.jpg" alt="Back" style={{ width: "32px" }} />
//     </button>
//     <h4 style={{ margin: 0, fontWeight: "700" }}>
//       {selectedParentAgency ? `Sub Agencies of ${selectedParentAgency.name}` : "Agency List"}
//     </h4>
//   </div>

//   <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//     {/* 26-09 */}
//     {!selectedParentAgency && (
//   <div style={{ width: "180px" }}>
//     <Select
//       classNamePrefix="mis-select"
//       options={[
//         { value: "Agency Admin", label: "Agency" },
//         { value: "New Agency Admin", label: "Sub Agency" },
//       ]}
//       value={
//         agencyFilterType
//           ? {
//               value: agencyFilterType,
//               label: agencyFilterType === "New Agency Admin" ? "Sub Agency" : "Agency",
//             }
//           : null
//       }
//       onChange={handleAgencyFilterChange}
//       placeholder="Choose Agency"
//       isClearable
//       isSearchable={false}
//     />
//   </div>
// )}
//      <div
//   style={{
//     position: "relative",
//     width: "190px",
//   }}
// ><img
//     src="/Search-32.png"
//     alt="search"
//     style={{
//       position: "absolute",
//       left: "10px",
//       top: "50%",
//       transform: "translateY(-50%)",
//       width: "18px",
//       height: "18px",
//       pointerEvents: "none",
//     }}
//   />
//     <input
//       type="text"
//       placeholder="Search Agency..."
//       value={search}
//       onChange={(e) => setSearch(e.target.value)}
//       style={{
//       width: "190px",
//       height: "38px",
//       padding: "8px 8px 8px 35px",
//       border: "1px solid #ccc",
//       borderRadius: "6px",
//       fontSize: "13px",
//       boxSizing: "border-box",
//     }}
 
//     />
//   </div></div>
// </div>

//               <div className="table-responsive">
//                 <table className="project-table">
//                   <thead>
//                     <tr>
//                       <th style={{ width: "60px" }}>Sr No</th>
//                       <th>Agency Name</th>
//                       <th>Unique_Agency_Code</th>
//                       {!selectedParentAgency &&  <th>City</th>}
//                       <th>Email</th>
//                       <th>Mobile</th>
//                     </tr>
//                   </thead>

//                   {/* <tbody>
//                     {currentSubAgencyList.map((item, index) => (
//                       // <tr key={index}>
// // 24 -09 agnecy fetching changes
//                        <tr
//       key={index}
//       onClick={() => handleAgencyRowClick(item)}
//       style={{ cursor: agencyFilterType === "Agency" && !selectedParentAgency ? "pointer" : "default" }}
//     >
//                         <td>{headIndexOfFirst + index + 1}</td>
//                         <td>{item.Agency_Name}</td>
//                         <td style={{color:"#5295c9", fontWeight:"700",textAlign:"center"}}>{item.Unique_Agency_Code}</td>
//                         <td>{item.City}</td>
//                         <td>{item.Email}</td>
//                         <td>{item.Mobile_Number}</td>
//                       </tr>
//                     ))}
//                   </tbody> */}

//                   <tbody>
//   {currentSubAgencyList.length > 0 ? (
//     currentSubAgencyList.map((item, index) => (
//       <tr
//         key={index}
//         onClick={() => handleAgencyRowClick(item)}
//         style={{ cursor: item.IsDrillable ? "pointer" : "default" }}
//       >
//         <td>{subAgencyIndexOfFirst + index + 1}</td>
//         <td>{item.Agency_Name}</td>
//         <td style={{ color: "#5295c9", fontWeight: "700", textAlign: "center" }}>
//           {item.Unique_Agency_Code}
//         </td>
//         {!selectedParentAgency && <td>{item.City}</td>}
//         <td>{item.Email}</td>
//         <td>{item.Mobile_Number}</td>
//       </tr>
//     ))
//   ) : (
//     <tr>
//       <td colSpan={selectedParentAgency ? 5 : 6} style={{ textAlign: "center", padding: "20px" }}>
//         No data available
//       </td>
//     </tr>
//   )}
// </tbody>
//                 </table>
//               </div>
//               <div
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginTop: "12px",
//                   padding: "8px 5px",
//                   boxSizing: "border-box",
//                 }}
//               >
//                 {/* Showing Entries */}
//                 <div
//                   style={{
//                     fontSize: "13px",
//                     color: "#333",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   Showing{" "}
//                   {subAgencyList.length === 0 ? 0 : subAgencyIndexOfFirst + 1}{" "}
//                   to {Math.min(subAgencyIndexOfLast, subAgencyList.length)} of{" "}
//                   {subAgencyList.length} entries
//                 </div>

//                 {/* Pagination */}
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "18px",
//                   }}
//                 >
//                   {/* Previous */}
//                   <button
//                     onClick={() =>
//                       setSubAgencyPage((prev) => Math.max(prev - 1, 1))
//                     }
//                     disabled={subAgencyPage === 1}
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: "#2ea4e7",
//                       cursor: subAgencyPage === 1 ? "not-allowed" : "pointer",
//                       fontSize: "13px",
//                       opacity: subAgencyPage === 1 ? 0.5 : 1,
//                     }}
//                   >
//                     ‹ Previous
//                   </button>

//                   {/* Page Numbers */}
//                   {/* Dynamic Page Numbers */}

//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "20px",
//                     }}
//                   >
//                     {getPageNumbers(subAgencyPage, subAgencyTotalPages).map(
//                       (pageNumber, index) => {
//                         if (pageNumber === "...") {
//                           return (
//                             <span
//                               key={`subagency-dots-${index}`}
//                               style={{
//                                 fontSize: "13px",
//                                 color: "#444",
//                               }}
//                             >
//                               ...
//                             </span>
//                           );
//                         }

//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => setSubAgencyPage(pageNumber)}
//                             style={{
//                               border: "none",
//                               background: "transparent",
//                               padding: 0,
//                               color:
//                                 subAgencyPage === pageNumber
//                                   ? "#2ea4e7"
//                                   : "#444",
//                               cursor: "pointer",
//                               fontSize: "13px",
//                               fontWeight:
//                                 subAgencyPage === pageNumber ? "600" : "400",
//                               textDecoration:
//                                 subAgencyPage === pageNumber
//                                   ? "underline"
//                                   : "none",
//                             }}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       },
//                     )}
//                   </div>

//                   {/* Next */}
//                   <button
//                     onClick={() =>
//                       setSubAgencyPage((prev) =>
//                         Math.min(prev + 1, subAgencyTotalPages),
//                       )
//                     }
//                     disabled={
//                       subAgencyPage === subAgencyTotalPages ||
//                       subAgencyTotalPages === 0
//                     }
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: "#2ea4e7",
//                       cursor:
//                         subAgencyPage === subAgencyTotalPages ||
//                         subAgencyTotalPages === 0
//                           ? "not-allowed"
//                           : "pointer",
//                       fontSize: "13px",
//                       opacity:
//                         subAgencyPage === subAgencyTotalPages ||
//                         subAgencyTotalPages === 0
//                           ? 0.5
//                           : 1,
//                     }}
//                   >
//                     Next ›
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {showTable === 9 && (
//             <div className="project-details-card">
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginBottom: "20px",
//                 }}
//               >
//                 <div
//                   style={{ display: "flex", alignItems: "center", gap: "12px" }}
//                 >
//                   <button
//                     // onClick={() => setShowTable(0)}
//                      onClick={() => {
//   setSearch("");
//   setShowTable(0);
// }} //10-10 for serach clear
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       cursor: "pointer",
//                     }}
//                   >
//                     <img
//                       src="/Back-Arrow-32.jpg"
//                       alt="Back"
//                       style={{ width: "32px" }}
//                     />
//                   </button>
//                   <h4 style={{ margin: 0, fontWeight: "700" }}>
//                     Total Head Details{" "}
//                   </h4>
//                 </div>
//                  <div
//   style={{
//     position: "relative",
//     width: "190px",
//   }}
// ><img
//     src="/Search-32.png"
//     alt="search"
//     style={{
//       position: "absolute",
//       left: "10px",
//       top: "50%",
//       transform: "translateY(-50%)",
//       width: "18px",
//       height: "18px",
//       pointerEvents: "none",
//     }}
//   />
//                 <input
//                   type="text"
//                   placeholder="Search Project..."
//                   value={search}
//                   onChange={(e) => setSearch(e.target.value)}
//                   onClick={handleSearch}
//                   style={{
//       width: "190px",
//       height: "38px",
//       padding: "8px 8px 8px 35px",
//       border: "1px solid #ccc",
//       borderRadius: "6px",
//       fontSize: "13px",
//       boxSizing: "border-box",
//     }}
 
//                 />
//                 </div>
//               </div>

//               <div className="table-responsive">
//                 <table className="project-table">
//                   <thead>
//                     <tr>
//                       <th>Sr.No</th>
//                       <th>Head ID</th>
//                       <th>Financial Year</th>
//                       <th>Head Name</th>
//                       <th>object Code</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {currentHeadList.length > 0 ? (
//                       currentHeadList.map((item, index) => (
//                         <tr key={item.HeadID}>
//                           <td>{headIndexOfFirst + index + 1}</td>
//                           <td style={{color:"#5295c9", fontWeight:"700",textAlign:"center"}}>{item.HeadID}</td>
//                           <td>{item.FinancialYear}</td>
//                           <td>{item.HeadName}</td>
//                           <td>{item.ObjectCode}</td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         {/* 01-10 */}
//                         <td
//                           colSpan="5"
//                           style={{ textAlign: "center", padding: "20px" }}
//                         >
//                           No Head Found
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//               <div
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginTop: "12px",
//                   padding: "8px 5px",
//                   boxSizing: "border-box",
//                 }}
//               >
//                 {/* Showing Entries */}
//                 <div
//                   style={{
//                     fontSize: "13px",
//                     color: "#333",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   Showing{" "}
//                   {headAssignList.length === 0 ? 0 : headIndexOfFirst + 1} to{" "}
//                   {Math.min(headIndexOfLast, headAssignList.length)} of{" "}
//                   {headAssignList.length} entries
//                 </div>

//                 {/* Pagination */}
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "18px",
//                   }}
//                 >
//                   {/* Previous */}
//                   <button
//                     onClick={() => setHeadPage((prev) => Math.max(prev - 1, 1))}
//                     disabled={headPage === 1}
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: "#2ea4e7",
//                       cursor: headPage === 1 ? "not-allowed" : "pointer",
//                       fontSize: "13px",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "5px",
//                       opacity: headPage === 1 ? 0.5 : 1,
//                     }}
//                   >
//                     <span style={{ fontSize: "16px" }}>‹</span>
//                     Previous
//                   </button>

//                   {/* Page Numbers */}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "20px",
//                     }}
//                   >
//                     {getPageNumbers(headPage, headTotalPages).map(
//                       (pageNumber, index) => {
//                         if (pageNumber === "...") {
//                           return (
//                             <span
//                               key={`head-dots-${index}`}
//                               style={{
//                                 fontSize: "13px",
//                                 color: "#444",
//                               }}
//                             >
//                               ...
//                             </span>
//                           );
//                         }

//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => setHeadPage(pageNumber)}
//                             style={{
//                               border: "none",
//                               background: "transparent",
//                               padding: 0,
//                               color:
//                                 headPage === pageNumber ? "#2ea4e7" : "#444",
//                               cursor: "pointer",
//                               fontSize: "13px",
//                               fontWeight:
//                                 headPage === pageNumber ? "600" : "400",
//                               textDecoration:
//                                 headPage === pageNumber ? "underline" : "none",
//                             }}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       },
//                     )}
//                   </div>

//                   {/* Next */}
//                   <button
//                     onClick={() =>
//                       setHeadPage((prev) => Math.min(prev + 1, headTotalPages))
//                     }
//                     disabled={
//                       headPage === headTotalPages || headTotalPages === 0
//                     }
//                     style={{
//                       border: "none",
//                       background: "transparent",
//                       padding: 0,
//                       color: "#2ea4e7",
//                       cursor:
//                         headPage === headTotalPages || headTotalPages === 0
//                           ? "not-allowed"
//                           : "pointer",
//                       fontSize: "13px",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "5px",
//                       opacity:
//                         headPage === headTotalPages || headTotalPages === 0
//                           ? 0.5
//                           : 1,
//                     }}
//                   >
//                     Next
//                     <span style={{ fontSize: "16px" }}>›</span>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default MisReports;


import React, { useContext, useEffect, useRef, useState } from "react";
import AdminContext from "../../../StateContext/Application";
import ReactApexChart from "react-apexcharts";
import "./MisReport.css";
import Select from "react-select";
import {
  Approved32,
  Click32,
  Disable32,
  Earnings,
  Earningss,
  Earningsss,
  Error32,
  fifth,
  first,
  forth,
  Graph64,
  MoreMenu64,
  NewTasks64,
  Sales,
  Second,
  Spendthismonth64,
  third,
  TotalProjects64,
  Unclick32,
  YourBalance,
  ECSFile,
  TotalAmountRelease,
  TotalDeductionAmount,
  TotalDemandGenerations,
  TotalWorkOrders,
  TotalProjectCost,
  TotalEsitmateAmount,
  TotalHeadsAssigns,
  DeleteIcon,
  EditIcon,
  BudgetHeadCreationBlue32,
} from "../../../../../public/LoginImages/importimages";
import "../../../../Users/pages/innercss.css";
const MisReports = () => {
  const content = useContext(AdminContext);
  const { GetProjectInfo, GetBudgetHeadInfo, MisReports } = content;
  const [schemeType, setSchemeType] = useState("");
  const [projectdata, setProjectData] = useState([]);
  const [search, setSearch] = useState("");
  const [showTable, setShowTable] = useState(0);
  const [showCards, setShowCards] = useState(false);
  const [showPage, setShowPage] = useState(0);
  // const [misData, setMisData] = useState({});
  const [workOrderList, setWorkOrderList] = useState([]);
  const [yearList, setYearList] = useState([]);
  const [agencyList, setAgencyList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [year, setYear] = useState("");
  const [agency, setAgency] = useState("");
  const [projectId, setProjectId] = useState("");
  const [billList, setBillList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [limitAllocationList, setLimitAllocationList] = useState([]);
  const [fundList, setFundList] = useState([]);
  // const [subAgencyList, setSubAgencyList] = useState([]);
  const [headAssignList, setheadAssignList] = useState([]);
  const [progressReportList, setProgressReportList] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);
  const [yearMenuOpen, setYearMenuOpen] = useState(false);
  const [agencyMenuOpen, setAgencyMenuOpen] = useState(false);
  const [projectMenuOpen, setProjectMenuOpen] = useState(false);
  const [projectPage, setProjectPage] = useState(1);
  const [billPage, setBillPage] = useState(1);
  const [deductionPage, setDeductionPage] = useState(1);
  const [vendorPage, setVendorPage] = useState(1);
  // const [vendorList, setVendorList] = useState([]);
  // const [subAgencyPage, setSubAgencyPage] = useState(1);
  const [headPage, setHeadPage] = useState(1);
  const [limitPage, setLimitPage] = useState(1);
  const [fundPage, setFundPage] = useState(1);
  const [deductionList, setDeductionList] = useState([]);
  const [progressPage, setProgressPage] = useState(1);


  // 24-09 agnecy fecthing cahngse

  const [subAgencyList, setSubAgencyList] = useState([]);
const [subAgencyPage, setSubAgencyPage] = useState(1);
const [agencyFilterType, setAgencyFilterType] = useState(""); // was "Agency"
const [selectedParentAgency, setSelectedParentAgency] = useState(null);



  const [misData, setMisData] = useState({
    TotalProjects: 0,
    BillAmount: 0,
    DeductionAmount: 0,
    TotalVendor: 0,
    TotalLimitAllocation: 0,
    FundAmount: 0,
    TotalSubAgency: 0,
    TotalHeadsAssign: 0,
    TotalProgressReport: 0,
  });

  const requestIdRef = useRef({});

  const GetAgency = async () => {
    const data = await MisReports({ type: "GetAgency" });
    setAgencyList(data);
  };

  const GetYears = async () => {
    const res = await MisReports({ type: "GetYears" });
    console.log("Frontend Years:", res);
    setYearList(res);
  };

  const GetProject = async () => {
    const data = await MisReports({ type: "GetProject" });
    setProjectList(data || []);
  };


  const fetchOverallTotals = async () => {
    await Promise.all([
      TestMisApi("Project", "", "", "", ""),
      TestMisApi("BillAmount", "", "", "", ""),
      TestMisApi("DeductionAmount", "", "", "", ""),
      TestMisApi("Vendor", "", "", "", ""),
      TestMisApi("LimitAllocation", "", "", "", ""),
      TestMisApi("FundAmount", "", "", "", ""),
      TestMisApi("SubAgency", "", "", "", ""),
      TestMisApi("ProgressReport", "", "", "", ""),
      TestMisApi("HeadAssign", "", "", "", ""),
    ]);
  };

  useEffect(() => {
    GetYears();
    GetAgency();
    GetProject();
    fetchOverallTotals();
  }, []);

  const handleYearChange = async (e) => {
    if (!schemeType) {
      alert("Please select Scheme first.");
      return;
    }
    const value = e.target.value;
    setYear(value);
    setAgency("");
    setProjectId("");
    const data = await MisReports({
      type: "GetAgency",
      Scheme: schemeType,
      FinancialYear: value,
    });
    setAgencyList(data || []);
    await Promise.all([
      TestMisApi("Project", "", schemeType, value),
      TestMisApi("BillAmount", "", schemeType, value),
      TestMisApi("DeductionAmount", "", schemeType, value),
      TestMisApi("LimitAllocation", "", schemeType, value),
      TestMisApi("FundAmount", "", schemeType, value),
      TestMisApi("SubAgency", "", schemeType, value),
      TestMisApi("ProgressReport", "", schemeType, value),
      ...(schemeType === "Budget"
        ? [TestMisApi("HeadAssign", "", schemeType, value)]
        : []),
    ]);
  };

  const handleAgencyChange = async (e) => {
    if (!schemeType) {
      alert("Please select Scheme first.");
      return;
    }

    if (!year) {
      alert("Please select Year first.");
      return;
    }
    const value = e.target.value;
    setAgency(value);
    setProjectId("");

    const data = await MisReports({
      type: "GetProject",
      Scheme: schemeType,
      FinancialYear: year,
      Agency_Name: value,
    });
    setProjectList(data || []);
    await Promise.all([
      TestMisApi("Project", value, schemeType, year),
      TestMisApi("BillAmount", value, schemeType, year),
      TestMisApi("DeductionAmount", value, schemeType, year),
      TestMisApi("LimitAllocation", value, schemeType, year),
      TestMisApi("FundAmount", value, schemeType, year),
      TestMisApi("SubAgency", value, schemeType, year),
      TestMisApi("ProgressReport", value, schemeType, year),
      ...(schemeType === "Budget"
        ? [TestMisApi("HeadAssign", value, schemeType, year)]
        : []),
    ]);
  };

  const handleProjectChange = async (e) => {
    if (!schemeType) {
      alert("Please select Scheme first.");
      return;
    }
    if (!year) {
      alert("Please select Year first.");
      return;
    }
    if (!agency) {
      alert("Please select Agency first.");
      return;
    }
    const value = e.target.value;
    setProjectId(value);
    await Promise.all([
      TestMisApi("Project", agency, schemeType, year, value),
      TestMisApi("BillAmount", agency, schemeType, year, value),
      TestMisApi("DeductionAmount", agency, schemeType, year, value),
      TestMisApi("LimitAllocation", agency, schemeType, year, value),
      TestMisApi("FundAmount", agency, schemeType, year, value),
      TestMisApi("ProgressReport", agency, schemeType, year, value),
      ...(schemeType === "Budget"
        ? [TestMisApi("HeadAssign", agency, schemeType, year, value)]
        : []),
    ]);
  };

  useEffect(() => {
    console.log("Scheme Changed:", schemeType);
  }, [schemeType]);

  console.log("misData", misData);
  const handleSchemeChange = async (e) => {
    const value = e.target.value;
    setSchemeType(value);
    setYear("");
    setAgency("");
    setProjectId("");
    setAgencyList([]);
    setProjectList([]);

    setMisData({
      TotalProjects: 0,
      BillAmount: 0,
      DeductionAmount: 0,
      TotalVendor: 0,
      TotalLimitAllocation: 0,
      FundAmount: 0,
      TotalSubAgency: 0,
      TotalHeadsAssign: 0,
      TotalProgressReport: 0,
    });

    // Scheme cleared back to "Choose Scheme" — show the overall (unfiltered)
    // totals again, same as on initial page load, instead of leaving the
    // cards at 0.
    if (!value) {
      await fetchOverallTotals();
      return;
    }

    await Promise.all([
      TestMisApi("Project", "", value),
      TestMisApi("BillAmount", "", value),
      TestMisApi("DeductionAmount", "", value),
      TestMisApi("LimitAllocation", "", value),
      TestMisApi("FundAmount", "", value),
      TestMisApi("SubAgency", "", value),
      TestMisApi("ProgressReport", "", value),
      ...(value === "Budget" ? [TestMisApi("HeadAssign", "", value)] : []),
    ]);

    GetYears();
  };

  const TestMisApi = async (
    type,
    agencyCode = agency,
    Scheme = schemeType,
    FinancialYear = year,
    project = projectId,
  ) => {
    
    const myRequestId = (requestIdRef.current[type] || 0) + 1;
    requestIdRef.current[type] = myRequestId;

    const res = await MisReports({
      type,
      Agency: agencyCode,
      Scheme,
      FinancialYear,
      ProjectId: project,
    });
    console.log("API Response:", res);


    if (requestIdRef.current[type] !== myRequestId) return;

    if (!res?.success) return;
 
    if (type === "Project") {
      console.log("PROJECT API RESPONSE:", res);

      setMisData((prev) => ({
        ...prev,
        TotalProjects: res.TotalProjects || 0,
        Budget_TotalProjects: res.Budget_TotalProjects || 0,
        NonBudget_TotalProjects: res.NonBudget_TotalProjects || 0,
      }));

 
      setProjectList(
        Array.isArray(res.ProjectList)
          ? res.ProjectList
          : Array.isArray(res.data)
            ? res.data
            : [],
      );
    } else if (type === "BillAmount") {
      setMisData((prev) => ({
        ...prev,
        BillAmount: res.BillAmount,
        Budget_BillAmount: res.Budget_BillAmount,
        NonBudget_BillAmount: res.NonBudget_BillAmount,
      }));
      setBillList(res.BillList);
    } else if (type === "DeductionAmount") {
      setMisData((prev) => ({
        ...prev,
        DeductionAmount: res.DeductionAmount,
        Budget_DeductionAmount: res.Budget_DeductionAmount,
        NonBudget_DeductionAmount: res.NonBudget_DeductionAmount,
      }));
      setDeductionList(res.BillList);
    } else if (type === "Vendor") {
      setMisData((prev) => ({
        ...prev,
        TotalVendor: res.TotalVendor,
      }));
      setVendorList(res.VendorList);
    } else if (type === "LimitAllocation") {
      setMisData((prev) => ({
        ...prev,
        TotalLimitAllocation: res.TotalLimitAllocation,
        Budget_TotalLimitAllocation: res.Budget_TotalLimitAllocation,
        NonBudget_TotalLimitAllocation: res.NonBudget_TotalLimitAllocation,
      }));
      setLimitAllocationList(res.LimitAllocationList);
    } else if (type === "FundAmount") {
      setMisData((prev) => ({
        ...prev,
        FundAmount: res.FundAmount,
      }));
      setFundList(res.FundList);
    } else if (type === "SubAgency") {
      setMisData((prev) => ({
        ...prev,
        TotalSubAgency: res.TotalSubAgency,
      }));
      setSubAgencyList(res.SubAgencyList);
    } else if (type === "HeadAssign") {
      setMisData((prev) => ({
        ...prev,
        TotalHeadsAssign: res.TotalHeadsAssign,
      }));
      setheadAssignList(res.HeadAssignList);
    } else if (type === "ProgressReport") {
      setMisData((prev) => ({
        ...prev,
        TotalProgressReport: res.TotalProgressReport || 0,
      }));
      setProgressReportList(res.ProgressReportList || []);
    }
  };


  // 24-09 agnecy fetching changes

const handleCardClick = async (card) => {
  setLoadingTable(true);
  if (card.type === "SubAgency") {
    setAgencyFilterType("");
    if (agency) {
      setSelectedParentAgency({ name: agency, code: null });
      await fetchAgencyChildren(agency); 
    } else {
      setSelectedParentAgency(null);
      await fetchAgencyList();
    }
  } else {
    await TestMisApi(card.type, agency, schemeType, year, projectId);
  }
  setLoadingTable(false);
  setShowTable(card.id);
};


  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearch(value);
    await TestMisApi("Project", value);
    await TestMisApi("BillAmount", value);
    await TestMisApi("DeductionAmount", value);
    setShowCards(true);
  };

 
  const filteredProjects = (projectList || []).filter((p) => {
    const value = search.trim().toLowerCase();

    return (
      String(p.ProjectName || "")
        .toLowerCase()
        .includes(value) ||
      String(p.ProjectId || p.ProjectID || "")
        .toLowerCase()
        .includes(value) ||
      String(
        p.FinancialYear || p.financialyear || p.Financial_Year || p.FY || "",
      )
        .toLowerCase()
        .includes(value)
    );
  });

  const filteredBills = (billList || []).filter((item) => {
    const value = search.trim().toLowerCase();

    return (
      item.ProjectName?.toLowerCase().includes(value) ||
      item.ProjectID?.toString().includes(value) ||
      item.BillNumber?.toLowerCase().includes(value) ||
      item.VendorName?.toLowerCase().includes(value) ||
      item.Agency_Name?.toLowerCase().includes(value)
    );
  });

  // 19-10-2026 deduction pagination work
 const filteredDeductions = (deductionList || [])
  // hide entries where deduction amount is 0
  .filter((item) => Number(item.DeductionAmount || 0) > 0)
  .filter((item) => {
    const value = search.trim().toLowerCase();
    return (
      String(item.ProjectName || "").toLowerCase().includes(value) ||
      String(item.ProjectID || "").toLowerCase().includes(value) ||
      String(item.DemandGenerationID || "").toLowerCase().includes(value) ||
      String(item.ContractorName || "").toLowerCase().includes(value)
    );
  });

  
  const filteredVendors = (vendorList || []).filter((item) => {
    const value = search.trim().toLowerCase();
    return item.Bidder_CompanyName.toLowerCase().includes(value);
  });

  const filteredLimits = (limitAllocationList || []).filter((item) => {
    const value = search.trim().toLowerCase();
    return (
      item.ProjectName?.toLowerCase().includes(value) ||
      item.FinancialYear.toLowerCase().includes(value) ||
      item.BudgetHead.toLowerCase().includes(value) ||
      item.Agency_Name?.toLowerCase().includes(value)
    );
  });

  const filteredFunds = (fundList || []).filter((item) => {
    const value = search.trim().toLowerCase();
    return (
      item.Year.toLowerCase().includes(value) ||
      item.Status.toLowerCase().includes(value) ||
      item.FundAmount.toLowerCase().includes(value) ||
      item.UTRNumber.toLowerCase().includes(value) ||
      item.LetterNumber.toLowerCase().includes(value) ||
      item.GRNumber.toLowerCase().includes(value)
    );
  });

 
  // 26-09 filter 
  const filteredAgency = (subAgencyList || []).filter((item) => {
  const value = search.trim().toLowerCase();

  const matchesSearch =
    (item.Agency_Name || "").toLowerCase().includes(value) ||
    (item.City || "").toLowerCase().includes(value) ||
    (item.Email || "").toLowerCase().includes(value);

  const matchesFilter =
    !agencyFilterType || selectedParentAgency || item.RoleType === agencyFilterType;

  return matchesSearch && matchesFilter;
});

  const filteredHead = (headAssignList || []).filter((item) => {
    const value = search.trim().toLowerCase();
    return (
      item.FinancialYear.toLowerCase().includes(value) ||
      item.HeadName.toLowerCase().includes(value)
    );
  });


// 05-10 add serach functionality
const filteredProgressList = (progressReportList || []).filter((item) => {
  const value = search.trim().toLowerCase();

  return (
    String(item.ProjectID || "")
      .toLowerCase()
      .includes(value) ||
    String(item.ProjectName || "")
      .toLowerCase()
      .includes(value) ||
    String(item.FinancialYear || "")
      .toLowerCase()
      .includes(value) ||
    String(item.WorkName || "")
      .toLowerCase()
      .includes(value)
  );
});

const filteredProjectList = (projectList || []).filter((item) => {
  const value = search.trim().toLowerCase();

  return (
    String(item.ProjectId || item.ProjectID || "")
      .toLowerCase()
      .includes(value) ||
    String(item.ProjectName || "")
      .toLowerCase()
      .includes(value) ||
    String(
      item.FinancialYear ||
        item.financialyear ||
        item.Financial_Year ||
        item.FY ||
        ""
    )
      .toLowerCase()
      .includes(value)
  );
});
// ---------

  const TotalProjects =
    schemeType === "Budget"
      ? misData?.Budget_TotalProjects
      : schemeType === "NonBudget"
        ? misData?.NonBudget_TotalProjects
        : misData?.TotalProjects;
  const BillAmount =
    schemeType === "Budget"
      ? misData?.Budget_BillAmount
      : schemeType === "NonBudget"
        ? misData?.NonBudget_BillAmount
        : misData?.BillAmount;
  const DeductionAmount =
    schemeType === "Budget"
      ? misData?.Budget_DeductionAmount
      : schemeType === "NonBudget"
        ? misData?.NonBudget_DeductionAmount
        : misData?.DeductionAmount;
  const TotalLimitAllocation =
    schemeType === "Budget"
      ? misData?.Budget_TotalLimitAllocation
      : schemeType === "NonBudget"
        ? misData?.NonBudget_TotalLimitAllocation
        : misData?.TotalLimitAllocation;

  const TotalProgressReport =
    schemeType === "Budget"
      ? misData?.Budget_TotalProgressReport
      : schemeType === "NonBudget"
        ? misData?.NonBudget_TotalProgressReport
        : misData?.TotalProgressReport;

  const cards = [
    {
      id: 1,
      title: "Total Project Cost",
      value: Number(TotalProjects || 0).toLocaleString("en-IN"),
     icon: "/MIS-Total Project Cost.png",
      showArrow: true,
      type: "Project",
    },
    {
      id: 2,
      title: "Total Bill Amount",
      value: `₹ ${Number(BillAmount || 0).toLocaleString("en-IN")}`,
         icon: "/MIS-Total-Bill-Amount.png",
      showArrow: true,
      type: "BillAmount",
    },
    {
      id: 3,
      title: "Total Deduction",
      value: `₹ ${Number(DeductionAmount || 0).toLocaleString("en-IN")}`,
      icon: "/MIS-Total-Deduction.png",
      showArrow: true,
      type: "DeductionAmount",
    },
    {
      id: 4,
      title: "Total Number Of Vendor",
      value: misData.TotalVendor || 0,
      icon: "/MIS-Total-Number-Of-Vendor.png",
      showArrow: true,
      type: "Vendor",
    },
    {
      id: 5,
      title: "Total Limit Allocation",
      value: `₹ ${Number(TotalLimitAllocation || 0).toLocaleString("en-IN")}`,
      icon: "/MIS-Total-Limit-Allocation.png",
      showArrow: true,
      type: "LimitAllocation",
    },
    {
      id: 6,
      title: "Total Fund Amount",
      value: `₹ ${Number(misData.FundAmount || 0).toLocaleString("en-IN")}`,
       icon: "/MIS-Total-Fund-Amount.png",
      showArrow: true,
      type: "FundAmount",
    },
    {
      id: 7,
      title: "Total Progress Report",
      value: misData.TotalProgressReport || 0,
     icon: "/MIS-Total-Progress-Report.png",
      showArrow: true,
      type: "ProgressReport",
    },
    {
      id: 8,
      title: "Total Agency",
      value: misData.TotalSubAgency || 0,
       icon: "/MIS-Total-Sub-Agency.png",
      showArrow: true,
      type: "SubAgency",
    },
  ];

  const displayCards =
    schemeType === "Budget"
      ? [
          ...cards,
          {
            id: 9,
            title: "Total Head Assign",
            value: misData.TotalHeadsAssign || 0,
            icon: "/MIS-Total-Number-Of-Vendor.png",
            showArrow: true,
            type: "HeadAssign",
            style: { border: "1px solid black", borderRadius: "8px", }, 
          },
        ]
      : cards;

  const getPageNumbers = (currentPage, totalPages) => {
    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    if (currentPage <= 3) {
      return [1, 2, 3, 4, 5, "...", totalPages];
    }

    if (currentPage >= totalPages - 2) {
      return [
        1,
        "...",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }

    return [
      1,
      "...",
      currentPage - 1,
      currentPage,
      currentPage + 1,
      "...",
      totalPages,
    ];
  };

  // 05-10 add seraching functionallity
const projectPerPage = 10;

const projectTotalPages = Math.ceil(
  filteredProjectList.length / projectPerPage
);

const projectIndexOfLast = projectPage * projectPerPage;

const projectIndexOfFirst =
  projectIndexOfLast - projectPerPage;

const currentProjectList = filteredProjectList.slice(
  projectIndexOfFirst,
  projectIndexOfLast
);
  // ================= BILL DETAILS PAGINATION =================

  const billsPerPage = 10;

  const billTotalPages = Math.ceil(filteredBills.length / billsPerPage);

  const billIndexOfLast = billPage * billsPerPage;

  const billIndexOfFirst = billIndexOfLast - billsPerPage;

  const currentBillList = filteredBills.slice(
    billIndexOfFirst,
    billIndexOfLast,
  );

  // ================= DEDUCTION DETAILS PAGINATION =================

  const deductionsPerPage = 10;

 const deductionTotalPages = Math.ceil(
  filteredDeductions.length / deductionsPerPage,
);

  const deductionIndexOfLast = deductionPage * deductionsPerPage;

  const deductionIndexOfFirst = deductionIndexOfLast - deductionsPerPage;

  const currentDeductionList = filteredDeductions.slice(
  deductionIndexOfFirst,
  deductionIndexOfLast,
);

  // ================= VENDOR DETAILS PAGINATION =================

  const vendorsPerPage = 10;

  const vendorTotalPages = Math.ceil(filteredVendors.length / vendorsPerPage);

  const vendorIndexOfLast = vendorPage * vendorsPerPage;

  const vendorIndexOfFirst = vendorIndexOfLast - vendorsPerPage;

  const currentVendorList = filteredVendors.slice(
    vendorIndexOfFirst,
    vendorIndexOfLast,
  );

  const limitsPerPage = 10;

  const limitTotalPages = Math.ceil(filteredLimits.length / limitsPerPage);

  const limitIndexOfLast = limitPage * limitsPerPage;

  const limitIndexOfFirst = limitIndexOfLast - limitsPerPage;

  const currentLimitList = filteredLimits.slice(
    limitIndexOfFirst,
    limitIndexOfLast,
  );

  // ================= FUND DETAILS PAGINATION =================

  const fundsPerPage = 10;

  const fundTotalPages = Math.ceil(filteredFunds.length / fundsPerPage);

  const fundIndexOfLast = fundPage * fundsPerPage;

  const fundIndexOfFirst = fundIndexOfLast - fundsPerPage;

  const currentFundList = filteredFunds.slice(
    fundIndexOfFirst,
    fundIndexOfLast,
  );

  // ================= SUB AGENCY DETAILS PAGINATION =================

  const subAgenciesPerPage = 10;

  const subAgencyTotalPages = Math.ceil(
    filteredAgency.length / subAgenciesPerPage,
  );

  const subAgencyIndexOfLast = subAgencyPage * subAgenciesPerPage;

  const subAgencyIndexOfFirst = subAgencyIndexOfLast - subAgenciesPerPage;

  const currentSubAgencyList = filteredAgency.slice(
    subAgencyIndexOfFirst,
    subAgencyIndexOfLast,
  );

  // ================= TOTAL HEAD DETAILS PAGINATION =================

  const headsPerPage = 10;

  const headTotalPages = Math.ceil(filteredHead.length / headsPerPage);

  const headIndexOfLast = headPage * headsPerPage;

  const headIndexOfFirst = headIndexOfLast - headsPerPage;

  const currentHeadList = filteredHead.slice(headIndexOfFirst, headIndexOfLast);



  // 05-10 add seraching functionallity
 const progressPerPage = 10;

const progressTotalPages = Math.ceil(
  filteredProgressList.length / progressPerPage
);

const progressIndexOfLast = progressPage * progressPerPage;

const progressIndexOfFirst = progressIndexOfLast - progressPerPage;

const currentProgressList = filteredProgressList.slice(
  progressIndexOfFirst,
  progressIndexOfLast
);



  // 24-09 agnecy fetching functionality changes
const fetchAgencyList = async () => {
  const res = await MisReports({ type: "SubAgency", Agency: "" });
  setMisData((prev) => ({ ...prev, TotalSubAgency: res?.TotalSubAgency || 0 }));
  setSubAgencyList(res?.SubAgencyList || []);
  setSubAgencyPage(1);
};

const handleAgencyFilterChange = (selected) => {
  setAgencyFilterType(selected ? selected.value : ""); // clearing goes back to placeholder
  setSubAgencyPage(1);
};

const handleBackToAgencyList = async () => {
  setSelectedParentAgency(null);
  await fetchAgencyList();
};


// 26-09 fetching aagnec with child ex maker and checker
const fetchAgencyChildren = async (agencyCode) => {
  const res = await MisReports({ type: "SubAgency", Agency: agencyCode }); // was "AgencyChildren"
  setMisData((prev) => ({ ...prev, TotalSubAgency: res?.TotalSubAgency || 0 })); // was res?.TotalChildren
  setSubAgencyList(res?.SubAgencyList || []); // was res?.ChildrenList
  setSubAgencyPage(1);
};
const handleAgencyRowClick = async (item) => {
  if (!item.IsDrillable) return; // Agency Admin rows and staff rows do nothing on click
  setSelectedParentAgency({ name: item.Agency_Name, code: item.Unique_Agency_Code });
  await fetchAgencyChildren(item.Unique_Agency_Code);
};

  return (
    <>
      <div
        style={{
          background: "#eaebff", 
          width: "auto",
          maxHeight: "90vh",
          transition: "margin-left 0.3s ease",
          overflowY: "auto",
          msOverflowStyle: "none",
          scrollbarWidth: "none",
          padding: 20,
          fontFamily: "Inter, sans-serif",
       
          
        }}
        className="no-scrollbar"
      >
        
        <div className="mis-container">
         
          {showTable === 0 && (
            <>  
              <h5
                className="mis-heading"
                style={{
                  fontWeight: 800,
                  marginLeft: 20,
                  marginBottom: 20,
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  fontSize:"16px"
                }}
              >
                <img
                  src={"/Dashboard-Blue-32.png"}
                  alt="Project Icon"
                  style={{ width: 28, height: 28 }}
                />{" "}
                MIS Report
              </h5>
              {/* Filters */}
              <div className="mis-filter-section">
                <div className="mis-filter-row">
                  {/* Scheme */}
                  <div className="mis-filter-group">
                    <label>Scheme :</label>

                    <Select
                      classNamePrefix="mis-select"
                      options={[
                        { value: "Budget", label: "Budget" },
                        { value: "NonBudget", label: "Non Budget" },
                      ]}
                      value={
                        schemeType
                          ? {
                              value: schemeType,
                              label:
                                schemeType === "NonBudget"
                                  ? "Non Budget"
                                  : "Budget",
                            }
                          : null
                      }
                      onChange={(selected) =>
                        handleSchemeChange({
                          target: { value: selected ? selected.value : "" },
                        })
                      }
                      placeholder="Choose Scheme"
                      isSearchable
                      isClearable
                    />
                  </div>

                  {/* Year */}
                  <div className="mis-filter-group">
                    <label>Select Year :</label>

                    <Select
                      classNamePrefix="mis-select"
                      options={yearList.map((item) => ({
                        value: item.FinancialYear,
                        label: item.FinancialYear,
                      }))}
                      value={year ? { value: year, label: year } : null}
                      onChange={(selected) =>
                        handleYearChange({
                          target: { value: selected ? selected.value : "" },
                        })
                      }
                      placeholder="Choose Year"
                      isSearchable
                      isClearable
                      onMenuOpen={() => {
                        if (!schemeType) {
                          alert("Please select Scheme first.");
                          setYearMenuOpen(false);
                        } else {
                          setYearMenuOpen(true);
                        }
                      }}
                      onMenuClose={() => setYearMenuOpen(false)}
                    />
                  </div>

                  {/* Agency */}
                  <div className="mis-filter-group">
                    <label>Select Agency :</label>

                    <Select
                      classNamePrefix="mis-select"
                      options={agencyList.map((item) => ({
                        value: item.Agency_Name,
                        label: item.Agency_Name,
                      }))}
                      value={agency ? { value: agency, label: agency } : null}
                      onChange={(selected) =>
                        handleAgencyChange({
                          target: { value: selected ? selected.value : "" },
                        })
                      }
                      placeholder="Choose Agency"
                      isSearchable
                      isClearable
                      onMenuOpen={() => {
                        if (!schemeType) {
                          alert("Please select Scheme first.");
                          setAgencyMenuOpen(false);
                        } else if (!year) {
                          alert("Please select Year first.");
                          setAgencyMenuOpen(false);
                        } else {
                          setAgencyMenuOpen(true);
                        }
                      }}
                      onMenuClose={() => setAgencyMenuOpen(false)}
                    />
                  </div>
                      <div style={{marginBottom:"0px"}} className="mis-filter-group">
                        <label>Select Project :</label>

                        <Select
                          classNamePrefix="mis-select"
                          options={(projectList || []).map((item) => ({
                            value: item.ProjectId,
                            label: item.ProjectName,
                          }))}
                          value={
                            projectList
                              .map((item) => ({
                                value: item.ProjectId,
                                label: item.ProjectName,
                              }))
                              .find((opt) => opt.value === projectId) || null
                          }
                          onChange={(selected) =>
                            handleProjectChange({
                              target: { value: selected ? selected.value : "" },
                            })
                          }
                          placeholder="Choose Project"
                          isSearchable
                          isClearable
                          noOptionsMessage={() => "No project found"}
                          onMenuOpen={() => {
                            if (!schemeType) {
                              alert("Please select Scheme first.");
                              setProjectMenuOpen(false);
                            } else if (!year) {
                              alert("Please select Year first.");
                              setProjectMenuOpen(false);
                            } else if (!agency) {
                              alert("Please select Agency first.");
                              setProjectMenuOpen(false);
                            } else {
                              setProjectMenuOpen(true);
                            }
                          }}
                          onMenuClose={() => setProjectMenuOpen(false)}
                        />
                      </div>
                    {/* </div>
                  </div> */}
                </div>
              </div>

             
              {/* 29-10 for UI  */}
              {/* Cards */}
              <div style={{background:"#eaebff" ,padding:"30px",marginTop:"0px"}}>
<div   className="mis-card-wrapper">
  {displayCards.map((item, index) => (
    <div className="mis-card" key={index}>
      <div className="mis-card-icon">
        <img src={item.icon} alt={item.title} />
      </div>
      <div className="mis-card-content">
        <h6>{item.title}</h6>
        <h3>{item.value}</h3>
      </div>
      {item.showArrow && (
        <div
          className="metric-arrow"
          onClick={() => handleCardClick(item)}
          style={{ cursor: "pointer" }}
        >
          <img src="/Arrow64.png" alt="arrow" className="metric-arrow-img" />
        </div>
      )}
    </div>
  ))}
</div>
 </div>
            </>
          )}

          {/* =============table show=================== */}

          {showTable === 1 && (
            <div className="mis-table-card">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  <button
                    // onClick={() => setShowTable(0)}
                      onClick={() => {
  setSearch("");
  setShowTable(0);
}} //10-10 for serach clear
                    style={{
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src="/Back-Arrow-32.jpg"
                      alt="Back"
                      style={{ width: "32px" }}
                    />
                  </button>
                  <h4 style={{ margin: 0, fontWeight: "700" }}>
                    Total Projects Details{" "}
                  </h4>
                </div>
                {/* 24-09 search change */}
                 <div
  style={{
    position: "relative",
    width: "190px",
  }}
>
  <img
    src="/Search-32.png"
    alt="search"
    style={{
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      width: "18px",
      height: "18px",
      pointerEvents: "none",
    }}
  />
                <input
                  type="text"
                  placeholder="Search Project..."
                  value={search}
                  // onChange={(e) => setSearch(e.target.value) } 05-10
         onChange={(e) => {
  setSearch(e.target.value);
  setProjectPage(1);
}}
                  onClick={handleSearch}
                  
                    style={{
      width: "190px",
      height: "38px",
      padding: "8px 8px 8px 35px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      fontSize: "13px",
      boxSizing: "border-box",
    }}
 
                  
                />
                </div>
              </div>

              <div className="mis-table-wrap">
                <table  style={{borderRadius:"5px"}} className="mis-table">
                  <thead>
                    <tr>
                      <th style={{ width: "60px" }}>Sr.No</th>
                       <th>Financial Year</th>
                      <th>Project ID</th>
                      <th>Project Name</th>
                      <th>Project Cost</th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentProjectList.length > 0 ? (
                      currentProjectList.map((item, index) => (
                        <tr key={item.ProjectId || index}>
                          <td>{projectIndexOfFirst + index + 1}</td>
 <td style={{textAlign:"center"}}>
                            {item.FinancialYear ||
                              item.financialyear ||
                              item.Financial_Year ||
                              item.FY ||
                              "--"}
                          </td>
                          <td style={{ textAlign: "center" ,    color: "rgb(82, 149, 201)"}}>
                            {item.ProjectId || item.ProjectID || "--"}
                          </td>

                          <td>{item.ProjectName || "--"}</td>

                         

                          <td>
                            ₹{" "}
                            {item.ProjectCost !== undefined &&
                            item.ProjectCost !== null &&
                            item.ProjectCost !== ""
                              ? Number(item.ProjectCost).toLocaleString("en-IN")
                              : item.Project_Cost !== undefined &&
                                  item.Project_Cost !== null
                                ? Number(item.Project_Cost).toLocaleString(
                                    "en-IN",
                                  )
                                : "--"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="5"
                          style={{
                            textAlign: "center",
                            padding: "20px",
                          }}
                        >
                          No Project Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/* -----------pagination add --20-08----- */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "12px",
                  padding: "8px 5px",
                  boxSizing: "border-box",
                }}
              >
                {/* Showing Entries */}
                <div
                  style={{
                    fontSize: "13px",
                    color: "#333",
                    whiteSpace: "nowrap",
                  }}
                >
                  {/* 05-10 */}
                  Showing{" "}
{filteredProjectList.length === 0 ? 0 : projectIndexOfFirst + 1} to{" "}
{Math.min(projectIndexOfLast, filteredProjectList.length)} of{" "}
{filteredProjectList.length} entries
                </div>

                {/* Pagination */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "18px",
                  }}
                >
                  {/* Previous */}
                  <button
                    onClick={() =>
                      setProjectPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={projectPage === 1}
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: "#2ea4e7",
                      cursor: projectPage === 1 ? "not-allowed" : "pointer",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      opacity: projectPage === 1 ? 0.5 : 1,
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>‹</span>
                    Previous
                  </button>

                  {/* Dynamic Page Numbers */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    {getPageNumbers(projectPage, projectTotalPages).map(
                      (pageNumber, index) => {
                        if (pageNumber === "...") {
                          return <span key={`project-dots-${index}`}>...</span>;
                        }

                        return (
                          <button
                            key={pageNumber}
                            onClick={() => setProjectPage(pageNumber)}
                            style={{
                              border: "none",
                              background: "transparent",
                              padding: 0,
                              color:
                                projectPage === pageNumber ? "#2ea4e7" : "#444",
                              cursor: "pointer",
                              fontSize: "13px",
                              fontWeight:
                                projectPage === pageNumber ? "600" : "400",
                              textDecoration:
                                projectPage === pageNumber
                                  ? "underline"
                                  : "none",
                            }}
                          >
                            {pageNumber}
                          </button>
                        );
                      },
                    )}
                  </div>

                  {/* Next */}
                  <button
                    onClick={() =>
                      setProjectPage((prev) =>
                        Math.min(prev + 1, projectTotalPages),
                      )
                    }
                    disabled={
                      projectPage === projectTotalPages ||
                      projectTotalPages === 0
                    }
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: "#2ea4e7",
                      cursor:
                        projectPage === projectTotalPages ||
                        projectTotalPages === 0
                          ? "not-allowed"
                          : "pointer",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      opacity:
                        projectPage === projectTotalPages ||
                        projectTotalPages === 0
                          ? 0.5
                          : 1,
                    }}
                  >
                    Next
                    <span style={{ fontSize: "16px" }}>›</span>
                  </button>
                </div>
              </div>
            </div>
          )}

          {showTable === 2 && (
            <div className="mis-table-card">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  <button
                    // onClick={() => setShowTable(0)}
                     onClick={() => {
  setSearch("");
  setShowTable(0);
}} //10-10 for serach clear
                    style={{
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src="/Back-Arrow-32.jpg"
                      alt="Back"
                      style={{ width: "32px" }}
                    />
                  </button>
                  <h4 style={{ margin: 0, fontWeight: "700" }}>
                    Bill Details{" "}
                  </h4>
                </div>
                 <div
  style={{
    position: "relative",
    width: "190px",
  }}
>
  <img
    src="/Search-32.png"
    alt="search"
    style={{
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      width: "18px",
      height: "18px",
      pointerEvents: "none",
    }}
  />
                <input
                  type="text"
                  placeholder="Search Project..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onClick={handleSearch}
                   style={{
      width: "190px",
      height: "38px",
      padding: "8px 8px 8px 35px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      fontSize: "13px",
      boxSizing: "border-box",
    }}
 
                />
                </div>
              </div>

              <div className="mis-table-wrap">
                <table  style={{borderRadius:"5px"}}  className="mis-table">
                  <thead>
                    <tr>
                      <th style={{ width: "60px" }}>Sr No</th>
                      <th>Demand ID</th>
                      <th>Project Name</th>
                      <th>Contractor Name</th>
                      <th>RA Bill No</th>
                      <th>Bill Amount</th>
                      <th>Deduction Amount</th>
                      <th>Net Payable</th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentBillList.length > 0 ? (
                      currentBillList.map((item, index) => (
                        <tr key={item.DemandGenerationID}>
                          <td>{billIndexOfFirst + index + 1}</td>
                          <td style={{ color: "rgb(82, 149, 201)",textAlign:"center"}}>{item.DemandGenerationID}</td>
                          <td>{item.ProjectName}</td>
                          <td>{item.ContractorName}</td>
                          <td>{item.RABillNumber}</td>
                          <td>
                            {" "}
                            ₹{" "}
                            {Number(item.BillAmount || 0).toLocaleString(
                              "en-IN",
                            )}{" "}
                          </td>
                          <td>
                            {" "}
                            ₹{" "}
                            {Number(item.DeductionAmount || 0).toLocaleString(
                              "en-IN",
                            )}{" "}
                          </td>
                          <td>
                            {" "}
                            ₹{" "}
                            {Number(item.NetPayableAmount || 0).toLocaleString(
                              "en-IN",
                            )}{" "}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" style={{ textAlign: "center" }}>
                          {" "}
                          No Bill Found{" "}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/* pagination add---20-08 */}

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "12px",
                  padding: "8px 5px",
                  boxSizing: "border-box",
                }}
              >
                {/* Showing Entries */}
                <div
                  style={{
                    fontSize: "13px",
                    color: "#333",
                    whiteSpace: "nowrap",
                  }}
                >
                  Showing {billList.length === 0 ? 0 : billIndexOfFirst + 1} to{" "}
                  {Math.min(billIndexOfLast, billList.length)} of{" "}
                  {billList.length} entries
                </div>

                {/* Pagination */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "18px",
                  }}
                >
                  {/* Previous */}
                  <button
                    onClick={() => setBillPage((prev) => Math.max(prev - 1, 1))}
                    disabled={billPage === 1}
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: "#2ea4e7",
                      cursor: billPage === 1 ? "not-allowed" : "pointer",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      opacity: billPage === 1 ? 0.5 : 1,
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>‹</span>
                    Previous
                  </button>

                  {/* Dynamic Page Numbers */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    {getPageNumbers(billPage, billTotalPages).map(
                      (pageNumber, index) => {
                        if (pageNumber === "...") {
                          return (
                            <span
                              key={`bill-dots-${index}`}
                              style={{
                                fontSize: "13px",
                                color: "#444",
                              }}
                            >
                              ...
                            </span>
                          );
                        }

                        return (
                          <button
                            key={pageNumber}
                            onClick={() => setBillPage(pageNumber)}
                            style={{
                              border: "none",
                              background: "transparent",
                              padding: 0,
                              color:
                                billPage === pageNumber ? "#2ea4e7" : "#444",
                              cursor: "pointer",
                              fontSize: "13px",
                              fontWeight:
                                billPage === pageNumber ? "600" : "400",
                              textDecoration:
                                billPage === pageNumber ? "underline" : "none",
                            }}
                          >
                            {pageNumber}
                          </button>
                        );
                      },
                    )}
                  </div>

                  {/* Next */}
                  <button
                    onClick={() =>
                      setBillPage((prev) => Math.min(prev + 1, billTotalPages))
                    }
                    disabled={
                      billPage === billTotalPages || billTotalPages === 0
                    }
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: "#2ea4e7",
                      cursor:
                        billPage === billTotalPages || billTotalPages === 0
                          ? "not-allowed"
                          : "pointer",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      opacity:
                        billPage === billTotalPages || billTotalPages === 0
                          ? 0.5
                          : 1,
                    }}
                  >
                    Next
                    <span style={{ fontSize: "16px" }}>›</span>
                  </button>
                </div>
              </div>
            </div>
          )}

          {showTable === 3 && (
            <div className="mis-table-card">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  <button
                    // onClick={() => setShowTable(0)}
                     onClick={() => {
  setSearch("");
  setShowTable(0);
}} //10-10 for serach clear
                    style={{
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src="/Back-Arrow-32.jpg"
                      alt="Back"
                      style={{ width: "32px" }}
                    />
                  </button>
                  <h4 style={{ margin: 0, fontWeight: "700" }}>
                    Deduction Details{" "}
                  </h4>
                </div>
                 <div
  style={{
    position: "relative",
    width: "190px",
  }}
><img
    src="/Search-32.png"
    alt="search"
    style={{
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      width: "18px",
      height: "18px",
      pointerEvents: "none",
    }}
  />
                <input
                  type="text"
                  placeholder="Search Project..."
                  value={search}
                  // onChange={(e) => setSearch(e.target.value)}
                  // 19-10
                  onChange={(e) => {
  setSearch(e.target.value);
  setDeductionPage(1);
}}

                  // onClick={handleSearch}
                  style={{
      width: "190px",
      height: "38px",
      padding: "8px 8px 8px 35px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      fontSize: "13px",
      boxSizing: "border-box",
    }}
 
                />
                </div>
              </div>

              <div className="mis-table-wrap">
                <table  style={{borderRadius:"5px"}} className="mis-table">
                  <thead>
                    <tr>
                      <th style={{ width: "60px" }}>Sr No</th>
                      <th>Demand ID</th>
                      <th>Project Name</th>
                      <th>Bill Amount</th>
                      <th>Deduction Amount</th>
                      <th>Net Payable</th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentDeductionList.length > 0 ? (
                      currentDeductionList.map((item, index) => (
                        <tr key={item.DemandGenerationID}>
                          {/* <td>{index + 1}</td> */}
                          {/* 19-10 */}
                          <td>{deductionIndexOfFirst + index + 1}</td>
                          <td style={{ color: "rgb(82, 149, 201)", textAlign:"center"}}>{item.DemandGenerationID}</td>
                          <td>{item.ProjectName}</td>
                          <td>
                            {" "}
                            ₹{" "}
                            {Number(item.BillAmount || 0).toLocaleString(
                              "en-IN",
                            )}{" "}
                          </td>
                          <td>
                            {" "}
                            ₹{" "}
                            {Number(item.DeductionAmount || 0).toLocaleString(
                              "en-IN",
                            )}{" "}
                          </td>
                          <td>
                            {" "}
                            ₹{" "}
                            {Number(item.NetPayableAmount || 0).toLocaleString(
                              "en-IN",
                            )}{" "}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        {/* 01-10 */}
                        <td colSpan="6" style={{ textAlign: "center" }}>
                          {" "}
                          No Deduction Found{" "}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "12px",
                  padding: "8px 5px",
                  boxSizing: "border-box",
                }}
              >
                {/* Showing Entries */}
                <div
                  style={{
                    fontSize: "13px",
                    color: "#333",
                    whiteSpace: "nowrap",
                  }}
                >
                  {" "}
                  {/* Showing{" "}
                  {deductionList.length === 0
                    ? 0
                    : deductionIndexOfFirst + 1}{" "}
                  to {Math.min(deductionIndexOfLast, deductionList.length)} of{" "}
                  {deductionList.length} entries */}
                  {/* 19-10  */}
                  Showing{" "}
{filteredDeductions.length === 0
  ? 0
  : deductionIndexOfFirst + 1}{" "}
to {Math.min(deductionIndexOfLast, filteredDeductions.length)} of{" "}
{filteredDeductions.length} entries 
                </div>

                {/* Pagination */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  {/* Previous */}
                  <button
                    onClick={() =>
                      setDeductionPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={deductionPage === 1}
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: "#2ea4e7",
                      cursor: deductionPage === 1 ? "not-allowed" : "pointer",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      opacity: deductionPage === 1 ? 0.5 : 1,
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>‹</span>
                    Previous
                  </button>

                  {/* Page Numbers */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    {getPageNumbers(deductionPage, deductionTotalPages).map(
                      (pageNumber, index) => {
                        if (pageNumber === "...") {
                          return (
                            <span
                              key={`deduction-dots-${index}`}
                              style={{
                                fontSize: "13px",
                                color: "#444",
                              }}
                            >
                              ...
                            </span>
                          );
                        }

                        return (
                          <button
                            key={pageNumber}
                            onClick={() => setDeductionPage(pageNumber)}
                            style={{
                              border: "none",
                              background: "transparent",
                              padding: 0,
                              color:
                                deductionPage === pageNumber
                                  ? "#2ea4e7"
                                  : "#444",
                              cursor: "pointer",
                              fontSize: "13px",
                              fontWeight:
                                deductionPage === pageNumber ? "600" : "400",
                              textDecoration:
                                deductionPage === pageNumber
                                  ? "underline"
                                  : "none",
                            }}
                          >
                            {pageNumber}
                          </button>
                        );
                      },
                    )}
                  </div>
                  {/* Next */}
                  <button
                    onClick={() =>
                      setDeductionPage((prev) =>
                        Math.min(prev + 1, deductionTotalPages),
                      )
                    }
                    disabled={
                      deductionPage === deductionTotalPages ||
                      deductionTotalPages === 0
                    }
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: "#2ea4e7",
                      cursor:
                        deductionPage === deductionTotalPages ||
                        deductionTotalPages === 0
                          ? "not-allowed"
                          : "pointer",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      opacity:
                        deductionPage === deductionTotalPages ||
                        deductionTotalPages === 0
                          ? 0.5
                          : 1,
                    }}
                  >
                    Next
                    <span style={{ fontSize: "16px" }}>›</span>
                  </button>
                </div>
              </div>
            </div>
          )}

          {showTable === 4 && (
            <div className="mis-table-card">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  <button
                    // onClick={() => setShowTable(0)}
                     onClick={() => {
  setSearch("");
  setShowTable(0);
}} //10-10 for serach clear
                    style={{
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src="/Back-Arrow-32.jpg"
                      alt="Back"
                      style={{ width: "32px" }}
                    />
                  </button>
                  <h4 style={{ margin: 0, fontWeight: "700" }}>
                    Vendors Details
                  </h4>
                </div>
                 <div
  style={{
    position: "relative",
    width: "190px",
  }}
><img
    src="/Search-32.png"
    alt="search"
    style={{
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      width: "18px",
      height: "18px",
      pointerEvents: "none",
    }}
  />
                <input
                  type="text"
                  placeholder="Search Project..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onClick={handleSearch}
                   style={{
      width: "190px",
      height: "38px",
      padding: "8px 8px 8px 35px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      fontSize: "13px",
      boxSizing: "border-box",
    }}
 
                />
                </div>
              </div>
              <div className="mis-table-wrap">
                <table  style={{borderRadius:"5px"}}  className="mis-table">
                  <thead>
                    <tr>
                      <th style={{ width: "60px" }}>Sr No</th>
                      <th>Vendor ID</th>
                      <th>Company Name</th>
                      <th>Mobile</th>
                      <th>Email</th>
                      <th>GST No</th>
                      <th>PAN No</th>
                      <th>Bank Name</th>
                      <th>Branch</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentVendorList.length > 0 ? (
                      currentVendorList.map((item, index) => (
                        <tr key={item.UniqueID}>
                          <td>{vendorIndexOfFirst + index + 1}</td>
                          <td style={{ color: "rgb(82, 149, 201)",textAlign:"center"}}>{item.UniqueID}</td>
                          <td>{item.Bidder_CompanyName}</td>
                          <td>{item.Mobile_No}</td>
                          <td>{item.Email}</td>
                          <td>{item.GST_No}</td>
                          <td>{item.PAN_No}</td>
                          <td>{item.BANK_NAME}</td>
                          <td>{item.BranchName}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" style={{ textAlign: "center" }}>
                          {" "}
                          No Vendor Found{" "}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "12px",
                  padding: "8px 5px",
                  boxSizing: "border-box",
                }}
              >
                {/* Showing Entries */}
                <div
                  style={{
                    fontSize: "13px",
                    color: "#333",
                    whiteSpace: "nowrap",
                  }}
                >
                  Showing {vendorList.length === 0 ? 0 : vendorIndexOfFirst + 1}{" "}
                  to {Math.min(vendorIndexOfLast, vendorList.length)} of{" "}
                  {vendorList.length} entries
                </div>

                {/* Pagination */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "18px",
                  }}
                >
                  {/* Previous */}
                  <button
                    onClick={() =>
                      setVendorPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={vendorPage === 1}
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: "#2ea4e7",
                      cursor: vendorPage === 1 ? "not-allowed" : "pointer",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      opacity: vendorPage === 1 ? 0.5 : 1,
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>‹</span>
                    Previous
                  </button>

                  {/* Page Numbers */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    {getPageNumbers(vendorPage, vendorTotalPages).map(
                      (pageNumber, index) => {
                        if (pageNumber === "...") {
                          return (
                            <span
                              key={`vendor-dots-${index}`}
                              style={{
                                fontSize: "13px",
                                color: "#444",
                              }}
                            >
                              ...
                            </span>
                          );
                        }

                        return (
                          <button
                            key={pageNumber}
                            onClick={() => setVendorPage(pageNumber)}
                            style={{
                              border: "none",
                              background: "transparent",
                              padding: 0,
                              color:
                                vendorPage === pageNumber ? "#2ea4e7" : "#444",
                              cursor: "pointer",
                              fontSize: "13px",
                              fontWeight:
                                vendorPage === pageNumber ? "600" : "400",
                              textDecoration:
                                vendorPage === pageNumber
                                  ? "underline"
                                  : "none",
                            }}
                          >
                            {pageNumber}
                          </button>
                        );
                      },
                    )}
                  </div>

                  {/* Next */}
                  <button
                    onClick={() =>
                      setVendorPage((prev) =>
                        Math.min(prev + 1, vendorTotalPages),
                      )
                    }
                    disabled={
                      vendorPage === vendorTotalPages || vendorTotalPages === 0
                    }
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: "#2ea4e7",
                      cursor:
                        vendorPage === vendorTotalPages ||
                        vendorTotalPages === 0
                          ? "not-allowed"
                          : "pointer",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      opacity:
                        vendorPage === vendorTotalPages ||
                        vendorTotalPages === 0
                          ? 0.5
                          : 1,
                    }}
                  >
                    Next
                    <span style={{ fontSize: "16px" }}>›</span>
                  </button>
                </div>
              </div>
            </div>
          )}

          {showTable === 5 && (
            <div className="mis-table-card">
              {/* Header */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  <button
                    // onClick={() => setShowTable(0)}
                     onClick={() => {
  setSearch("");
  setShowTable(0);
}} //10-10 for serach clear
                    style={{
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src="/Back-Arrow-32.jpg"
                      alt="Back"
                      style={{ width: "32px" }}
                    />
                  </button>
                  <h4 style={{ margin: 0, fontWeight: "700" }}>
                    {" "}
                    Limit Allocation Details{" "}
                  </h4>
                </div>
                 <div
  style={{
    position: "relative",
    width: "190px",
  }}
><img
    src="/Search-32.png"
    alt="search"
    style={{
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      width: "18px",
      height: "18px",
      pointerEvents: "none",
    }}
  />
                <input
                  type="text"
                  placeholder="Search Project..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onClick={handleSearch}
                  style={{
      width: "190px",
      height: "38px",
      padding: "8px 8px 8px 35px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      fontSize: "13px",
      boxSizing: "border-box",
    }}
 
                />
              </div></div>
              <div className="mis-table-wrap">
                <table  style={{borderRadius:"5px"}}  className="mis-table">
                  <thead>
                    <tr>
                      <th style={{ width: "60px" }}>Sr No</th>
                      <th>Release ID</th>
                      <th>Financial Year</th>
                      <th>Project Name</th>
                      {schemeType === "Budget" && <th>Budget Head</th>}
                      <th>Agency</th>
                      <th>Release Amount</th>
                      <th>Release Date</th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentLimitList.length > 0 ? (
                      currentLimitList.map((item, index) => (
                        <tr key={item.ReleaseID}>
                          <td>{limitIndexOfFirst + index + 1}</td>
                          <td style={{ color: "rgb(82, 149, 201)",textAlign:"center"}}>{item.ReleaseID}</td>
                          <td>{item.FinancialYear}</td>
                          <td>{item.ProjectName}</td>
                          {schemeType === "Budget" && (
                            <td>{item.BudgetHead}</td>
                          )}
                          <td>{item.AgencyName}</td>
                          <td>
                            {" "}
                            ₹{" "}
                            {Number(item.ReleaseAmount || 0).toLocaleString(
                              "en-IN",
                            )}{" "}
                          </td>
                          <td>
                            {" "}
                            {new Date(item.ReleaseDate).toLocaleDateString(
                              "en-GB",
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" style={{ textAlign: "center" }}>
                          {" "}
                          No Limit Alloacation Found{" "}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "12px",
                  padding: "8px 5px",
                  boxSizing: "border-box",
                }}
              >
                {/* Showing Entries */}
                <div
                  style={{
                    fontSize: "13px",
                    color: "#333",
                    whiteSpace: "nowrap",
                  }}
                >
                  Showing{" "}
                  {limitAllocationList.length === 0 ? 0 : limitIndexOfFirst + 1}{" "}
                  to {Math.min(limitIndexOfLast, limitAllocationList.length)} of{" "}
                  {limitAllocationList.length} entries
                </div>

                {/* Pagination */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "18px",
                  }}
                >
                  {/* Previous */}
                  <button
                    onClick={() =>
                      setLimitPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={limitPage === 1}
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: "#2ea4e7",
                      cursor: limitPage === 1 ? "not-allowed" : "pointer",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      opacity: limitPage === 1 ? 0.5 : 1,
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>‹</span>
                    Previous
                  </button>

                  {/* Page Numbers */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    {getPageNumbers(limitPage, limitTotalPages).map(
                      (pageNumber, index) => {
                        if (pageNumber === "...") {
                          return (
                            <span
                              key={`limit-dots-${index}`}
                              style={{
                                fontSize: "13px",
                                color: "#444",
                              }}
                            >
                              ...
                            </span>
                          );
                        }

                        return (
                          <button
                            key={pageNumber}
                            onClick={() => setLimitPage(pageNumber)}
                            style={{
                              border: "none",
                              background: "transparent",
                              padding: 0,
                              color:
                                limitPage === pageNumber ? "#2ea4e7" : "#444",
                              cursor: "pointer",
                              fontSize: "13px",
                              fontWeight:
                                limitPage === pageNumber ? "600" : "400",
                              textDecoration:
                                limitPage === pageNumber ? "underline" : "none",
                            }}
                          >
                            {pageNumber}
                          </button>
                        );
                      },
                    )}
                  </div>

                  {/* Next */}
                  <button
                    onClick={() =>
                      setLimitPage((prev) =>
                        Math.min(prev + 1, limitTotalPages),
                      )
                    }
                    disabled={
                      limitPage === limitTotalPages || limitTotalPages === 0
                    }
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: "#2ea4e7",
                      cursor:
                        limitPage === limitTotalPages || limitTotalPages === 0
                          ? "not-allowed"
                          : "pointer",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      opacity:
                        limitPage === limitTotalPages || limitTotalPages === 0
                          ? 0.5
                          : 1,
                    }}
                  >
                    Next
                    <span style={{ fontSize: "16px" }}>›</span>
                  </button>
                </div>
              </div>
            </div>
          )}

          {showTable === 6 && (
            <div className="mis-table-card">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  <button
                    // onClick={() => setShowTable(0)}
                     onClick={() => {
  setSearch("");
  setShowTable(0);
}} //10-10 for serach clear
                    style={{
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src="/Back-Arrow-32.jpg"
                      alt="Back"
                      style={{ width: "32px" }}
                    />
                  </button>
                  <h4 style={{ margin: 0, fontWeight: "700" }}>
                    Funds Details{" "}
                  </h4>
                </div>
                 <div
  style={{
    position: "relative",
    width: "190px",
  }}
><img
    src="/Search-32.png"
    alt="search"
    style={{
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      width: "18px",
      height: "18px",
      pointerEvents: "none",
    }}
  />
                <input
                  type="text"
                  placeholder="Search Project..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onClick={handleSearch}
                   style={{
      width: "190px",
      height: "38px",
      padding: "8px 8px 8px 35px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      fontSize: "13px",
      boxSizing: "border-box",
    }}
 
                />
              </div>
              </div>
              <div className="mis-table-wrap">
                <table  style={{borderRadius:"5px"}} className="mis-table">
                  <thead>
                    <tr>
                      <th style={{ width: "60px" }}>Sr No</th>
                      <th>Fund ID</th>
                      <th>Year</th>
                      <th>GR Number</th>
                      <th>Letter Number</th>
                      <th>UTR Number</th>
                      <th>Fund Amount</th>
                      <th>Used Fund</th>
                      <th>Remaining Fund</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {/* {currentFundList.map((item, index) => ( */}
                    {/* 01-10 */}
                     {currentFundList.length > 0 ? (
    currentFundList.map((item, index) => (
 
                      <tr key={index}>
                        <td>{fundIndexOfFirst + index + 1}</td>
                        <td style={{ color: "rgb(82, 149, 201)",textAlign:"center"}}>{item.FundID}</td>
                        <td>{item.Year}</td>
                        <td>{item.GRNumber}</td>
                        <td style={{whiteSpace:"normal"}}>{item.LetterNumber}</td>
                        <td style={{whiteSpace:"normal"}}>{item.UTRNumber}</td>
                        <td style={{whiteSpace:"normal"}}>
                          ₹ {Number(item.FundAmount).toLocaleString("en-IN")}
                        </td>
                        <td style={{whiteSpace:"normal"}}>
                          ₹{" "}
                          {Number(item.UsedFundAmount).toLocaleString("en-IN")}
                        </td>
                        <td style={{whiteSpace:"normal"}}>
                          ₹{" "}
                          {Number(item.RemainingFundAmount).toLocaleString(
                            "en-IN",
                          )}
                        </td>
                        <td>{item.Status}</td>
                      {/* </tr>
                    ))}
                  </tbody> */}
                  {/* 01-10 */}
                    </tr>
    ))
  ) : (
    <tr>
      <td
        colSpan="10"
        style={{
          textAlign: "center",
          padding: "20px",
          height: "50px",
          color: "#777",
          fontSize: "13px",
          fontWeight: "500",
        }}
      >
        No Fund Found
      </td>
    </tr>
  )}
</tbody>
 

                </table>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "12px",
                  padding: "8px 5px",
                  boxSizing: "border-box",
                }}
              >
                {/* Showing Entries */}
                <div
                  style={{
                    fontSize: "13px",
                    color: "#333",
                    whiteSpace: "nowrap",
                  }}
                >
                  Showing {fundList.length === 0 ? 0 : fundIndexOfFirst + 1} to{" "}
                  {Math.min(fundIndexOfLast, fundList.length)} of{" "}
                  {fundList.length} entries
                </div>

                {/* Pagination */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "18px",
                  }}
                >
                  {/* Previous */}
                  <button
                    onClick={() => setFundPage((prev) => Math.max(prev - 1, 1))}
                    disabled={fundPage === 1}
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: "#2ea4e7",
                      cursor: fundPage === 1 ? "not-allowed" : "pointer",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      opacity: fundPage === 1 ? 0.5 : 1,
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>‹</span>
                    Previous
                  </button>

                  {/* Page Numbers */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    {getPageNumbers(fundPage, fundTotalPages).map(
                      (pageNumber, index) => {
                        if (pageNumber === "...") {
                          return (
                            <span
                              key={`fund-dots-${index}`}
                              style={{
                                fontSize: "13px",
                                color: "#444",
                              }}
                            >
                              ...
                            </span>
                          );
                        }

                        return (
                          <button
                            key={pageNumber}
                            onClick={() => setFundPage(pageNumber)}
                            style={{
                              border: "none",
                              background: "transparent",
                              padding: 0,
                              color:
                                fundPage === pageNumber ? "#2ea4e7" : "#444",
                              cursor: "pointer",
                              fontSize: "13px",
                              fontWeight:
                                fundPage === pageNumber ? "600" : "400",
                              textDecoration:
                                fundPage === pageNumber ? "underline" : "none",
                            }}
                          >
                            {pageNumber}
                          </button>
                        );
                      },
                    )}
                  </div>

                  {/* Next */}
                  <button
                    onClick={() =>
                      setFundPage((prev) => Math.min(prev + 1, fundTotalPages))
                    }
                    disabled={
                      fundPage === fundTotalPages || fundTotalPages === 0
                    }
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: "#2ea4e7",
                      cursor:
                        fundPage === fundTotalPages || fundTotalPages === 0
                          ? "not-allowed"
                          : "pointer",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      opacity:
                        fundPage === fundTotalPages || fundTotalPages === 0
                          ? 0.5
                          : 1,
                    }}
                  >
                    Next
                    <span style={{ fontSize: "16px" }}>›</span>
                  </button>
                </div>
              </div>
            </div>
          )}

          {showTable === 7 && (
            <div className="mis-table-card">
              {" "}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 20,
                }}
              >
                {" "}
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  {" "}
                  <button
                    // onClick={() => setShowTable(0)}
                     onClick={() => {
  setSearch("");
  setShowTable(0);
}} //10-10 for serach clear
                    style={{
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                    }}
                  >
                    {" "}
                    <img
                      src="/Back-Arrow-32.jpg"
                      alt="Back"
                      style={{ width: 32 }}
                    />{" "}
                  </button>{" "}
                  <h4 style={{ margin: 0, fontWeight: "700" }}>
                    {" "}
                    Total Progress Report Details{" "}
                  </h4>{" "}
                </div>{" "}

{/* 05-10 add serch functionality */}
 <div
  style={{
    position: "relative",
    width: "190px",
  }}
><img
    src="/Search-32.png"
    alt="search"
    style={{
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      width: "18px",
      height: "18px",
      pointerEvents: "none",
    }}
  />
                <input
                  type="text"
                  placeholder="Search Project..."
                  value={search}
                  // onChange={(e) => setSearch(e.target.value)} 05-10
                  onChange={(e) => {
  setSearch(e.target.value);
  setProgressPage(1);
}}
                  onClick={handleSearch}
                   style={{
      width: "190px",
      height: "38px",
      padding: "8px 8px 8px 35px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      fontSize: "13px",
      boxSizing: "border-box",
    }}
 
                />
              </div>


              </div>{" "}
              <div className="mis-table-wrap">
                {" "}
                <table  style={{borderRadius:"5px"}} className="mis-table">
                  {" "}
                  <thead>
                    {" "}
                    <tr>
                      {" "}
                      <th style={{ width: "60px" }}>Sr No</th>{" "}
                      <th>Project ID</th> <th>Project Name</th>{" "}
                      <th>Financial Year</th> <th>Work Name</th>{" "}
                      <th>Physical Progress</th> <th>Creation Date</th>{" "}
                    </tr>{" "}
                  </thead>{" "}
                  <tbody>
                    {" "}
                    {currentProgressList.length > 0 ? (
                      currentProgressList.map((item, index) => (
                        <tr key={item.ID}>
                          {" "}
                          <td>{progressIndexOfFirst + index + 1}</td>{" "}
                          <td style={{ color: "rgb(82, 149, 201)", fontWeight:"700",textAlign:"center"}}>{item.ProjectID}</td> <td>{item.ProjectName}</td>{" "}
                          <td>{item.FinancialYear}</td> <td>{item.WorkName}</td>{" "}
                          <td>{item.PhysicalProgress}%</td>{" "}
                          <td>
                            {" "}
                            {new Date(item.CreationDate).toLocaleDateString(
                              "en-GB",
                            )}{" "}
                          </td>{" "}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        {" "}
                        <td colSpan="7" style={{ textAlign: "center" }}>
                          {" "}
                          No Progress Report Found{" "}
                        </td>{" "}
                      </tr>
                    )}{" "}
                  </tbody>{" "}
                </table>{" "}
              </div>{" "}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "12px",
                  padding: "8px 5px",
                  boxSizing: "border-box",
                }}
              >
                {/* Showing Entries */}
                <div
                  style={{
                    fontSize: "13px",
                    color: "#333",
                    whiteSpace: "nowrap",
                  }}
                >
                  
                  {/* 05-10 */}
                  Showing{" "}
{filteredProgressList.length === 0
  ? 0
  : progressIndexOfFirst + 1}{" "}
to {Math.min(progressIndexOfLast, filteredProgressList.length)}{" "}
of {filteredProgressList.length} entries
                </div>

                {/* Pagination */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  {/* Previous */}
                  <button
                    onClick={() =>
                      setProgressPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={progressPage === 1}
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: "#2ea4e7",
                      cursor: progressPage === 1 ? "not-allowed" : "pointer",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      opacity: progressPage === 1 ? 0.5 : 1,
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>‹</span>
                    Previous
                  </button>

                  {/* Page Numbers */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    {getPageNumbers(progressPage, progressTotalPages).map(
                      (pageNumber, index) => {
                        if (pageNumber === "...") {
                          return (
                            <span
                              key={`progress-dots-${index}`}
                              style={{
                                fontSize: "13px",
                                color: "#444",
                              }}
                            >
                              ...
                            </span>
                          );
                        }

                        return (
                          <button
                            key={pageNumber}
                            onClick={() => setProgressPage(pageNumber)}
                            style={{
                              border: "none",
                              background: "transparent",
                              padding: 0,
                              color:
                                progressPage === pageNumber
                                  ? "#2ea4e7"
                                  : "#444",
                              cursor: "pointer",
                              fontSize: "13px",
                              fontWeight:
                                progressPage === pageNumber ? "600" : "400",
                              textDecoration:
                                progressPage === pageNumber
                                  ? "underline"
                                  : "none",
                            }}
                          >
                            {pageNumber}
                          </button>
                        );
                      },
                    )}
                  </div>

                  {/* Next */}
                  <button
                    onClick={() =>
                      setProgressPage((prev) =>
                        Math.min(prev + 1, progressTotalPages),
                      )
                    }
                    disabled={
                      progressPage === progressTotalPages ||
                      progressTotalPages === 0
                    }
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: "#2ea4e7",
                      cursor:
                        progressPage === progressTotalPages ||
                        progressTotalPages === 0
                          ? "not-allowed"
                          : "pointer",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      opacity:
                        progressPage === progressTotalPages ||
                        progressTotalPages === 0
                          ? 0.5
                          : 1,
                    }}
                  >
                    Next
                    <span style={{ fontSize: "16px" }}>›</span>
                  </button>
                </div>
              </div>
            </div>
          )}

          {showTable === 8 && (
            <div className="mis-table-card">
             


              {/* 24-09 Agnecy fetching changes */}

              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "20px" }}>
  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
    <button
      onClick={() => (selectedParentAgency ? handleBackToAgencyList() : setShowTable(0))}
      style={{ border: "none", background: "transparent", cursor: "pointer" }}
    >
      <img src="/Back-Arrow-32.jpg" alt="Back" style={{ width: "32px" }} />
    </button>
    <h4 style={{ margin: 0, fontWeight: "700" }}>
      {selectedParentAgency ? `Sub Agencies of ${selectedParentAgency.name}` : "Agency List"}
    </h4>
  </div>

  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
    {/* 26-09 */}
    {!selectedParentAgency && (
  <div style={{ width: "180px" }}>
    <Select
      classNamePrefix="mis-select"
      options={[
        { value: "Agency Admin", label: "Agency" },
        { value: "New Agency Admin", label: "Sub Agency" },
      ]}
      value={
        agencyFilterType
          ? {
              value: agencyFilterType,
              label: agencyFilterType === "New Agency Admin" ? "Sub Agency" : "Agency",
            }
          : null
      }
      onChange={handleAgencyFilterChange}
      placeholder="Choose Agency"
      isClearable
      isSearchable={false}
    />
  </div>
)}
     <div
  style={{
    position: "relative",
    width: "190px",
  }}
><img
    src="/Search-32.png"
    alt="search"
    style={{
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      width: "18px",
      height: "18px",
      pointerEvents: "none",
    }}
  />
    <input
      type="text"
      placeholder="Search Agency..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      style={{
      width: "190px",
      height: "38px",
      padding: "8px 8px 8px 35px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      fontSize: "13px",
      boxSizing: "border-box",
    }}
 
    />
  </div></div>
</div>

              <div className="mis-table-wrap">
                <table  style={{borderRadius:"5px"}}  className="mis-table">
                  <thead>
                    <tr>
                      <th style={{ width: "60px" }}>Sr No</th>
                      <th>Agency Name</th>
                      <th>Unique_Agency_Code</th>
                      {!selectedParentAgency &&  <th>City</th>}
                      <th>Email</th>
                      <th>Mobile</th>
                    </tr>
                  </thead>

                 

                  <tbody>
  {currentSubAgencyList.length > 0 ? (
    currentSubAgencyList.map((item, index) => (
      <tr
        key={index}
        onClick={() => handleAgencyRowClick(item)}
        style={{ cursor: item.IsDrillable ? "pointer" : "default" }}
      >
        <td>{subAgencyIndexOfFirst + index + 1}</td>
        <td>{item.Agency_Name}</td>
        <td style={{  color: "rgb(82, 149, 201)", fontWeight: "700", textAlign: "center" }}>
          {item.Unique_Agency_Code}
        </td>
        {!selectedParentAgency && <td>{item.City}</td>}
        <td>{item.Email}</td>
        <td>{item.Mobile_Number}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={selectedParentAgency ? 5 : 6} style={{ textAlign: "center", padding: "20px" }}>
        No Agency Found
      </td>
    </tr>
  )}
</tbody>
                </table>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "12px",
                  padding: "8px 5px",
                  boxSizing: "border-box",
                }}
              >
                {/* Showing Entries */}
                <div
                  style={{
                    fontSize: "13px",
                    color: "#333",
                    whiteSpace: "nowrap",
                  }}
                >
                  Showing{" "}
                  {subAgencyList.length === 0 ? 0 : subAgencyIndexOfFirst + 1}{" "}
                  to {Math.min(subAgencyIndexOfLast, subAgencyList.length)} of{" "}
                  {subAgencyList.length} entries
                </div>

                {/* Pagination */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "18px",
                  }}
                >
                  {/* Previous */}
                  <button
                    onClick={() =>
                      setSubAgencyPage((prev) => Math.max(prev - 1, 1))
                    }
                    disabled={subAgencyPage === 1}
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: "#2ea4e7",
                      cursor: subAgencyPage === 1 ? "not-allowed" : "pointer",
                      fontSize: "13px",
                      opacity: subAgencyPage === 1 ? 0.5 : 1,
                    }}
                  >
                    ‹ Previous
                  </button>

                  {/* Page Numbers */}
                  {/* Dynamic Page Numbers */}

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    {getPageNumbers(subAgencyPage, subAgencyTotalPages).map(
                      (pageNumber, index) => {
                        if (pageNumber === "...") {
                          return (
                            <span
                              key={`subagency-dots-${index}`}
                              style={{
                                fontSize: "13px",
                                color: "#444",
                              }}
                            >
                              ...
                            </span>
                          );
                        }

                        return (
                          <button
                            key={pageNumber}
                            onClick={() => setSubAgencyPage(pageNumber)}
                            style={{
                              border: "none",
                              background: "transparent",
                              padding: 0,
                              color:
                                subAgencyPage === pageNumber
                                  ? "#2ea4e7"
                                  : "#444",
                              cursor: "pointer",
                              fontSize: "13px",
                              fontWeight:
                                subAgencyPage === pageNumber ? "600" : "400",
                              textDecoration:
                                subAgencyPage === pageNumber
                                  ? "underline"
                                  : "none",
                            }}
                          >
                            {pageNumber}
                          </button>
                        );
                      },
                    )}
                  </div>

                  {/* Next */}
                  <button
                    onClick={() =>
                      setSubAgencyPage((prev) =>
                        Math.min(prev + 1, subAgencyTotalPages),
                      )
                    }
                    disabled={
                      subAgencyPage === subAgencyTotalPages ||
                      subAgencyTotalPages === 0
                    }
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: "#2ea4e7",
                      cursor:
                        subAgencyPage === subAgencyTotalPages ||
                        subAgencyTotalPages === 0
                          ? "not-allowed"
                          : "pointer",
                      fontSize: "13px",
                      opacity:
                        subAgencyPage === subAgencyTotalPages ||
                        subAgencyTotalPages === 0
                          ? 0.5
                          : 1,
                    }}
                  >
                    Next ›
                  </button>
                </div>
              </div>
            </div>
          )}

          {showTable === 9 && (
            <div className="mis-table-card">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "12px" }}
                >
                  <button
                    // onClick={() => setShowTable(0)}
                     onClick={() => {
  setSearch("");
  setShowTable(0);
}} //10-10 for serach clear
                    style={{
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src="/Back-Arrow-32.jpg"
                      alt="Back"
                      style={{ width: "32px" }}
                    />
                  </button>
                  <h4 style={{ margin: 0, fontWeight: "700" }}>
                    Total Head Details{" "}
                  </h4>
                </div>
                 <div
  style={{
    position: "relative",
    width: "190px",
  }}
><img
    src="/Search-32.png"
    alt="search"
    style={{
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      width: "18px",
      height: "18px",
      pointerEvents: "none",
    }}
  />
                <input
                  type="text"
                  placeholder="Search Project..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onClick={handleSearch}
                  style={{
      width: "190px",
      height: "38px",
      padding: "8px 8px 8px 35px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      fontSize: "13px",
      boxSizing: "border-box",
    }}
 
                />
                </div>
              </div>

              <div className="mis-table-wrap">
                <table  style={{borderRadius:"5px"}}  className="mis-table">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Head ID</th>
                      <th>Financial Year</th>
                      <th>Head Name</th>
                      <th>object Code</th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentHeadList.length > 0 ? (
                      currentHeadList.map((item, index) => (
                        <tr key={item.HeadID}>
                          <td>{headIndexOfFirst + index + 1}</td>
                          <td style={{color:"#5295c9", fontWeight:"700",textAlign:"center"}}>{item.HeadID}</td>
                          <td>{item.FinancialYear}</td>
                          <td>{item.HeadName}</td>
                          <td>{item.ObjectCode}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        {/* 01-10 */}
                        <td
                          colSpan="5"
                          style={{ textAlign: "center", padding: "20px" }}
                        >
                          No Head Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginTop: "12px",
                  padding: "8px 5px",
                  boxSizing: "border-box",
                }}
              >
                {/* Showing Entries */}
                <div
                  style={{
                    fontSize: "13px",
                    color: "#333",
                    whiteSpace: "nowrap",
                  }}
                >
                  Showing{" "}
                  {headAssignList.length === 0 ? 0 : headIndexOfFirst + 1} to{" "}
                  {Math.min(headIndexOfLast, headAssignList.length)} of{" "}
                  {headAssignList.length} entries
                </div>

                {/* Pagination */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "18px",
                  }}
                >
                  {/* Previous */}
                  <button
                    onClick={() => setHeadPage((prev) => Math.max(prev - 1, 1))}
                    disabled={headPage === 1}
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: "#2ea4e7",
                      cursor: headPage === 1 ? "not-allowed" : "pointer",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      opacity: headPage === 1 ? 0.5 : 1,
                    }}
                  >
                    <span style={{ fontSize: "16px" }}>‹</span>
                    Previous
                  </button>

                  {/* Page Numbers */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    {getPageNumbers(headPage, headTotalPages).map(
                      (pageNumber, index) => {
                        if (pageNumber === "...") {
                          return (
                            <span
                              key={`head-dots-${index}`}
                              style={{
                                fontSize: "13px",
                                color: "#444",
                              }}
                            >
                              ...
                            </span>
                          );
                        }

                        return (
                          <button
                            key={pageNumber}
                            onClick={() => setHeadPage(pageNumber)}
                            style={{
                              border: "none",
                              background: "transparent",
                              padding: 0,
                              color:
                                headPage === pageNumber ? "#2ea4e7" : "#444",
                              cursor: "pointer",
                              fontSize: "13px",
                              fontWeight:
                                headPage === pageNumber ? "600" : "400",
                              textDecoration:
                                headPage === pageNumber ? "underline" : "none",
                            }}
                          >
                            {pageNumber}
                          </button>
                        );
                      },
                    )}
                  </div>

                  {/* Next */}
                  <button
                    onClick={() =>
                      setHeadPage((prev) => Math.min(prev + 1, headTotalPages))
                    }
                    disabled={
                      headPage === headTotalPages || headTotalPages === 0
                    }
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: "#2ea4e7",
                      cursor:
                        headPage === headTotalPages || headTotalPages === 0
                          ? "not-allowed"
                          : "pointer",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      opacity:
                        headPage === headTotalPages || headTotalPages === 0
                          ? 0.5
                          : 1,
                    }}
                  >
                    Next
                    <span style={{ fontSize: "16px" }}>›</span>
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MisReports;

